/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import { Box, CircularProgress, Grid, IconButton, Tooltip, Typography, Menu, MenuItem, Divider, useMediaQuery } from "@mui/material";
import _, { uniqueId } from "lodash";
import { memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector, batch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import styles from "../assets/styles/Hospital.module.scss";
import Card from "../components/dashboard/card/Card";
import dashboardStyles from "../components/dashboard/Dashboard.module.scss";
import DoctorCard from "../components/dashboard/doctorCard/DoctorCard";
import {
	DayCardList,
	DiagnosticsCardList,
	DischargeEmergencyList,
	FloorCardList,
	HospitalCardDetailsDialog,
	HospitalHeader,
	HospitalizationsList,
	HospitalSlider,
	NinetyDaysAnalysis,
	ReturnCardList,
	ShiftCard,
	TotalCountCircle,
	TotalTransferCard,
} from "../features/hospital/components";
import HospitalHeaderCardFilterPanel from "../features/hospital/components/HospitalHeaderCardFilterPanel";
import InsuranceCard from "../components/dashboard/InsuranceCard/InsuranceCard";
import SelectableCard from "../components/dashboard/selectableCard/SelectableCard";
import TaggedList from "../components/dashboard/shared/taggedList/TaggedList";
import usePdfReport from "../components/hooks/usePdfReport";
import Page from "../components/Page";
import ColorInfoBox from "../components/shared/dashboard/ColorInfoBox";
import DragDropLayout from "../components/shared/DragDropLayout";
import LayoutController from "../components/shared/LayoutController";
import { TYPES } from "../data/hospital.data";
import { getAllPatientCount } from "../services/hospital.service";
import {
	openDetailsDialog as openDetailsDialogComparison,
	setCardFilter as setCardFilterComparison,
	setFilterListDataHospital as setFilterListDataComparison,
	setPatientList as setPatientListComparison,
} from "../store/reducers/comparisonReducers/hospitalComparison.slice";
import {
	DEFAULT_FILTER_PAGE,
	DEFAULT_HOSPITAL_LIST,
	openDetailsDialog,
	setCardFilter,
	setDynamicCards,
	setIsSpecialComparison,
	setLockTotal,
	setLockedTotalBy,
	setMainTotal,
	setResetFilter,
	setTransferType,
	setLoading as setHospitalLoading,
	setCachedMainResult,
	setCachedComparisonResult,
	clearCachedResults,
	setDefaultCardEdited,
} from "../store/reducers/hospital.slice";
import { setHospitalLayout } from "../store/reducers/customCard.slice";
import { PATIENT_RELATION } from "../types/chart-dialog.type";
import { HOSPITAL_CARDS_LABELS, HOSPITAL_CARDS_TYPE } from "../types/hospital.type";
import { PAGE_TYPE } from "../types/pages.type";
import {
	calcProPercentsBasedOnFilterAndDays,
	getDynamicPercentageBy,
	getPercentageByTotal,
	isFullAccess,
	isOnlyHospitalOrTransfer,
	isOnlyHospitalTabAccess,
	itemPercentage,
	pickObjectByPaths,
	priorityFilter,
	processCustomRangeCombinedData,
	projectionPerMonth,
	selectedTabAccess,
	updateChartFilterByPriority,
	updateCurrentFilterListData,
} from "../utilis/common";
import { setIsLayoutMode } from "../store/reducers/common.slice";
import { toSaveDate, toSaveEndDate } from "../utilis/date-formats";
import { updateFilterListData } from "../utilis/hospital-common";
import { persistHospitalPageConverterCardContext } from "../services/page-converter-navigation.service";
import tooltipsInfo from "../utilis/tooltipContents";
import { setHospitalCards } from "../store/reducers/customCard.slice";
import { HOSPITAL_CUSTOM_CARD } from "../types/custom-card-type";
import AddCardDrawer from "../components/shared/add-filter-card/add-card-drawer";

import CardAnimation from "../components/shared/CardAnimation";
import ShadowLineWithText from "../components/shared/ShadowLineWithText";
import useSetParamToURL from "../components/hooks/useSetParamToURL";
import NoteContainer from "../components/shared/NoteContainer";
import { getQuestionsData } from "../services/dynamic-data-tab.service";
import useAdditionalData from "../components/hooks/useAdditionalData";
import { useDashboard } from "../context/DashboardContext";
import DynamicCardItem from "../components/shared/dynamic-card/DynamicCardItem";
import { usePageLayoutFetch } from "../hooks/usePageLayoutFetch";
import useAddCategoryFromMenu from "../hooks/useAddCategoryFromMenu";
import { usePageNotifications } from "../hooks/usePageNotifications";
import useIsMobileDevice from "../hooks/useIsMobileDevice";
import useSyncPreference from "../hooks/useSyncPreference";
import ShareNotificationDialog from "../components/shared/ShareNotificationDialog";
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { useAIChatContext } from "../hooks/useAIChatContext";
import { useAiChatAccess } from "../hooks/useAiChatAccess";
import useFilterTutorial from "../hooks/useFilterTutorial";
import { registerVectorStoreId } from "../services/vector-store-tracking.service";
import { getCardWidth } from "../constants/card-layout";
import {
	getCustomTabCardLayoutId,
	getDynamicCardLayoutId,
	resolveLayoutCardIdForSelectedCard,
} from "../utilis/layout-card-ids";
import { chartsData, chartGroupBy } from "../utilis/charts-common";
import { saveLayoutToDatabase } from "../services/layout.service";
import {
	applyCollapsedStateToLayout,
	getCollapsedIdsFromLayout,
} from "../utils/categoryCollapsedState";
import useCollapsedCategoriesPersistence from "../components/hooks/useCollapsedCategoriesPersistence";
import { findCategoryIdContainingCard } from "../utils/dashboardScrollToCard";
import { ADD_NOTIFICATION, REPORT_META_PATHS } from "../store/types";
import { AUTH_ROLES } from "../types/auth.type";
import ToastNotification from "../components/shared/ToastNotification";
import MobileCardList from "../components/shared/MobileCardList";
import { HospitalList } from "../features/admissions/components";
import RefreshIcon from "@mui/icons-material/Refresh";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import AiChatFloatButton from "../components/shared/ai-chat/AiChatFloatButton";
import AiChatDrawer from "../components/shared/ai-chat/AiChatDrawer";
// import aiCensusActionsService from "../services/ai-census-actions.service";
// import aiDateSuggestionsService from "../services/ai-date-suggestions.service";
// import aiDateActionsService from "../services/ai-date-actions.service";
// import aiFilterActionsService from "../services/ai-filter-actions.service";
// import aiReportActionsService from "../services/ai-report-actions.service";
// import aiTransferActionsService from "../services/ai-transfer-actions.service";
// import aiDialogActionsService from "../services/ai-dialog-actions.service";
import useFacilityId from "../hooks/useFacilityId";
import useAccountId from "../hooks/useAccountId";
import useShareReport from "../hooks/useShareReport";
import useSharedUsersByCustomTab from "../hooks/useSharedUsersByCustomTab";
import ShareNotesDialog from "../components/shared/notes/ShareNotesDialog";
import CategoryBox from "../components/shared/CategoryBox";
import HospitalCardLayoutPreview from "../features/hospital/components/layoutPreview/HospitalCardLayoutPreview";
import { ensureHospitalRootOrder } from "../utils/ensureHospitalRootOrder";
import {
	computeLayoutAfterCardMove,
	computeLayoutAfterRootGapInsert,
	estimateCategoryGridRowUnits,
	getPointerClientCoords,
	getStandaloneInsertBeforeIdFromPoint,
	getCategoryInsertBeforeTargetFromPoint,
	pointInRect,
	pointerOverHospitalRootStandaloneArea,
	resolveHospitalCategoryIdUnderPointer,
} from "../utils/hospitalCategoryLayoutHelpers";

/**
 * Layout mode dashboard zoom (`transform: scale(z)` + matching `width: calc(100%/z)`).
 * 1 = full size; smaller = more of the grid visible. Adjust here only.
 */
const HOSPITAL_LAYOUT_MODE_ZOOM_DESKTOP = 0.76;
const HOSPITAL_LAYOUT_MODE_ZOOM_MOBILE = 0.86;

/** Fix layouts that stored dynamic/custom cards under accessor instead of dynamic_… / custom_… grid ids. */
function normalizeHospitalLayoutCardIds(layout, dynamicCards, customTabs) {
	if (!layout) return layout;
	const mapCard = (c) => {
		if (!c || c.id == null) return c;
		const newId = resolveLayoutCardIdForSelectedCard(c.id, dynamicCards, customTabs);
		return newId === c.id ? c : { ...c, id: newId };
	};
	const mappedRootOrder = Array.isArray(layout.rootOrder)
		? layout.rootOrder
			.map((entry) => {
				if (!entry || entry.id == null) return entry;
				const nextId = resolveLayoutCardIdForSelectedCard(entry.id, dynamicCards, customTabs);
				return nextId === entry.id ? entry : { ...entry, id: nextId };
			})
			.filter(Boolean)
		: undefined;
	return {
		...layout,
		standalone: (layout.standalone || []).map(mapCard),
		categories: (layout.categories || []).map((cat) => ({
			...cat,
			cards: (cat.cards || []).map(mapCard),
		})),
		rootOrder: mappedRootOrder,
	};
}

/** Add standalone entries for selected cards missing from layout (dynamic/custom and new picks). */
function augmentHospitalLayoutWithSelectedCards(layout, hospitalCards, dynamicCards, customTabs) {
	if (!layout || !Array.isArray(hospitalCards) || hospitalCards.length === 0) return layout;

	const ownedBaseAccessors = new Set();

	// Process categories first to prioritize cards explicitly placed there
	const cleanCategories = (layout.categories || []).map(cat => {
		const cleanCards = [];
		(cat.cards || []).forEach(c => {
			const base = c.id.replace(/^(dynamic_|custom_)/, '');
			if (!ownedBaseAccessors.has(base)) {
				ownedBaseAccessors.add(base);
				cleanCards.push(c);
			}
		});
		return { ...cat, cards: cleanCards };
	});

	// Remove duplicates from standalone
	const cleanStandalone = [];
	(layout.standalone || []).forEach(c => {
		const base = c.id.replace(/^(dynamic_|custom_)/, '');
		if (!ownedBaseAccessors.has(base)) {
			ownedBaseAccessors.add(base);
			cleanStandalone.push(c);
		}
	});

	// Find truly missing cards
	const additions = [];
	for (const cId of hospitalCards) {
		const base = cId.replace(/^(dynamic_|custom_)/, '');
		if (!ownedBaseAccessors.has(base)) {
			ownedBaseAccessors.add(base);
			const gridId = resolveLayoutCardIdForSelectedCard(cId, dynamicCards, customTabs);
			additions.push({ id: gridId, width: getCardWidth(cId), gridH: 24 });
		}
	}

	const existingRootOrder = Array.isArray(layout.rootOrder) ? layout.rootOrder : [];
	const validStandaloneIds = new Set(cleanStandalone.map(c => c.id));
	const orderedIds = new Set();

	// Clean root order of duplicates that were removed
	const cleanRootOrder = existingRootOrder.filter(entry => {
		if (entry.type === 'category') {
			orderedIds.add(entry.id);
			return true;
		}
		if (validStandaloneIds.has(entry.id)) {
			orderedIds.add(entry.id);
			return true;
		}
		return false;
	});

	const appendedRootEntries = additions
		.filter((card) => !orderedIds.has(card.id))
		.map((card, idx) => ({
			id: card.id,
			type: "card",
			width: card.width || 4,
			position: cleanRootOrder.length + idx,
		}));

	const nextRootOrder = [...cleanRootOrder, ...appendedRootEntries].map((entry, idx) => ({
		...entry,
		position: idx,
	}));

	return {
		...layout,
		categories: cleanCategories,
		standalone: [...cleanStandalone, ...additions],
		rootOrder: nextRootOrder,
	};
}

// Stable "Move to category" menu used in the card headers while in layout
// mode. Defined at module scope (instead of being re-declared inside
// `renderCard` every render) so React sees the same component type across
// renders and doesn't remount every IconButton / Menu for every card on
// every drag tick — that remount was a big chunk of the layout-mode lag.
const HospitalMoveMenu = memo(function HospitalMoveMenu({
	card,
	currentLayout,
	categories,
	onMove,
	onAutoRemoveEmptyCategory,
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event) => {
		if (event) event.stopPropagation();
		setAnchorEl(null);
	};

	const handleMove = (categoryId) => {
		const result = onMove(card.id, categoryId);
		if (result === "done_removed_empty_category" && onAutoRemoveEmptyCategory) {
			const toTitle =
				categoryId === "standalone"
					? "General Cards"
					: categories.find((c) => c.id === categoryId)?.title || "category";
			onAutoRemoveEmptyCategory(toTitle);
		}
		handleClose();
	};

	return (
		<>
			<IconButton
				size="small"
				onClick={handleClick}
				sx={{ color: 'primary.main', mr: 1 }}
				onMouseDown={(e) => e.stopPropagation()}
			>
				<DriveFileMoveIcon fontSize="small" />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				onMouseDown={(e) => e.stopPropagation()}
			>
				<Typography variant="overline" sx={{ px: 2, color: 'text.secondary' }}>Move to:</Typography>
				<MenuItem
					onClick={() => handleMove('standalone')}
					disabled={currentLayout?.standalone?.some((c) => c.id === card.id)}
				>
					Standalone (No Box)
				</MenuItem>
				{categories.length > 0 && <Divider />}
				{categories.map((cat) => (
					<MenuItem
						key={cat.id}
						onClick={() => handleMove(cat.id)}
						disabled={cat.cards?.some((c) => c.id === card.id)}
					>
						{cat.title}
					</MenuItem>
				))}
			</Menu>
		</>
	);
});

const HospitalPage = () => {
	const isMobile = useIsMobileDevice();
	const compactCategoryInnerDesktop = useMediaQuery("(max-width:1280px)");
	const categoryInnerTwoCol = !isMobile && compactCategoryInnerDesktop;
	const dispatch = useDispatch();
	const mobileMenuOpen = useSelector(state => state.ui.mobileMenuOpen);
	const { downloadPdf, saveAutomaticReport, downloadExcel } = usePdfReport();
	const isOnlyHospitalDashboard = useMemo(() => {
		return isOnlyHospitalTabAccess();
	}, []);
	const [isDateUpdated, setIsDateUpdated] = useState(false);
	const [patientList, setPatientList] = useState(DEFAULT_HOSPITAL_LIST);
	const [searchParams] = useSearchParams();
	const {
		filterListData: filterListDataComparison,
		dbData: dbDataComparison,
		filter: filterComparison,
		cardFilter: cardFilterComparison,
		transferType: transferTypeComparison,
		patientList: patientListComparison,
		filterTotal: filterTotalComparison,
		facilityPercentage: facilityPercentageComparison,
		lockedTotal: lockedTotalComparison,
		lockedByFacility: lockedByFacilityComparison,
		isCensusTotalLocked: isCensusTotalLockedComparison,
	} = useSelector((state) => state.hospitalComparison);
	const [isHeaderVisible, setIsHeaderVisible] = useState(true);
	const [filterListData, setFilterListData] = useState(DEFAULT_FILTER_PAGE);
	/** After first filter recompute: rows matching active Hospital card filters. null = not computed yet (use raw list for converter). */
	const [pageConverterPatientSource, setPageConverterPatientSource] = useState(null);
	const {
		filter,
		dbData,
		lockedTotalBy,
		transferType,
		cardFilter,
		isResetFilter,
		detailsDialog,
		mainNumPercentage,
		lockedTotal,
		facilityPercentage,
		lockedByFacility,
		isCensusTotalLocked,
		specialComparisonSet,
		filterTotal,
		loading: hospitalLoading,
		dynamicCards,
		cachedMainResults,
		cachedComparisonResults,
		defaultCardEdited
	} = useSelector((state) => state.hospital);
	const { selectedAccount, percentageBy, isCustomTabAdded, isLayoutMode, customPercentageLabel, customePercentages, skipMainFetch } = useSelector((state) => state.common);
	const HOSPITAL_CUSTOM_CARD_DATA = useAdditionalData(dynamicCards, HOSPITAL_CUSTOM_CARD, patientList?.customTabs);
	const { sharedUsersByTabId: sharedUsersByCustomTabId, sharedWithEveryoneByTabId } = useSharedUsersByCustomTab(
		patientList?.customTabs,
		dynamicCards
	);

	const percentageAgainst = useMemo(() => {
		return getDynamicPercentageBy(dbData, percentageBy, isOnlyHospitalDashboard);
	}, [percentageBy, dbData, isOnlyHospitalDashboard]);

	const { rangesSet, comparingAgainstDifferentFacility, comparisonRanges } = useSelector(
		(state) => state.comparison
	);
	const activeFacilities = useSelector((state) => state.activeFacilities.facilities);
	const activeFacilitiesComparison = useSelector((state) => state.comparison.activeComparisonFacilitiesId);

	// Use ref to track previous facilities locally to avoid false positives on component remount
	const prevFacilitiesRef = useRef(null);
	const isInitialMountRef = useRef(true);
	const isInitialDataFetchRef = useRef(true);
	const prevIsCustomTabAddedRef = useRef(isCustomTabAdded);
	const lastMainFetchSignatureRef = useRef(null);
	const lastComparisonFetchSignatureRef = useRef(null);
	const facilities = useSelector((state) => state.facility); // Get all facilities for name mapping
	const triggerFilterTutorial = useFilterTutorial();
	const { lastADTDate, projectionDays } = useSelector((state) => state.common);
	const { facilityId: facilityIdFromHook } = useFacilityId();
	const { accountId: accountIdFromHook } = useAccountId();
	const activeFacilityLocalStorage = facilityIdFromHook;
	const fetchRequestRef = useRef(null);
	const fetchRequestRefComparison = useRef(null);

	// Clear cache when facilities change
	useEffect(() => {
		// Skip on initial mount - don't clear cache when component first loads
		if (isInitialMountRef.current) {
			isInitialMountRef.current = false;
			prevFacilitiesRef.current = [...activeFacilities].sort((a, b) => {
				const aStr = String(a);
				const bStr = String(b);
				return aStr.localeCompare(bStr);
			});
			return;
		}

		// Compare current facilities with previous facilities (from ref, not Redux)
		// This ensures we only clear cache when facilities actually change during component lifecycle
		const sortedActive = [...activeFacilities].sort((a, b) => {
			const aStr = String(a);
			const bStr = String(b);
			return aStr.localeCompare(bStr);
		});
		const sortedPrev = prevFacilitiesRef.current || [];
		const facilitiesActuallyChanged = !_.isEqual(sortedActive, sortedPrev);

		if (facilitiesActuallyChanged) {
			// Facilities changed - clear all cached results
			dispatch(clearCachedResults());
		}

		// Update ref with current facilities for next comparison
		prevFacilitiesRef.current = sortedActive;
	}, [activeFacilities, dispatch]);
	const { hospitalCards, hospitalLayout } = useSelector((state) => state.customCard);

	const activeRequestRef = useRef(null);

	// loading states
	const [loading, setLoading] = useState(true);
	const [loadingComparison, setLoadingComparison] = useState(false);

	// Track if data came from cache
	const [isDataFromCache, setIsDataFromCache] = useState(false);

	// Layout mode state - now managed by Redux
	const [hasLayoutChanges, setHasLayoutChanges] = useState(false);
	const [tempLayout, setTempLayout] = useState([]);
	const [currentLayoutType, setCurrentLayoutType] = useState('personal'); // 'personal' or 'default'
	const { fetchSavedLayout, fetchLayoutByType, fetchDefaultLayout } = usePageLayoutFetch(PAGE_TYPE.HOSPITAL);
	const [layoutTypeLoading, setLayoutTypeLoading] = useState(false);
	const [draggedCardId, setDraggedCardId] = useState(null);
	const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
	const [hoveredStandalone, setHoveredStandalone] = useState(false);
	const [dragSource, setDragSource] = useState(null);
	const [collapsedCategoryIds, setCollapsedCategoryIds] = useState({});
	const [dropFlashCategoryId, setDropFlashCategoryId] = useState(null);
	const hasInitializedCollapsedStateRef = useRef(false);
	const categoryRefs = useRef({});
	const handleToggleLayoutModeRef = useRef(null);
	const dropFlashTimeoutRef = useRef(null);
	const suppressCategoryInnerPersistRef = useRef(false);
	// Holds the latest `cardData` so callbacks declared higher in the file
	// (e.g. `handleRootGapDrop`) can read it without putting `cardData` in
	// their useCallback deps — that would trip the temporal dead zone since
	// `cardData` is a `const useMemo` declared further down.
	const cardDataRef = useRef([]);
	const draggedCardIdRef = useRef(null);
	const dragSourceRef = useRef(null);
	const hoveredStandaloneRef = useRef(false);
	const categoryDragPointerRef = useRef(null);
	const standaloneDropZoneRef = useRef(null);
	// Fix 3: Continuous pointer tracking during category drag for reliable hit-testing
	const lastPointerRef = useRef({ x: 0, y: 0, timestamp: 0 });
	const [hospitalGeneralDropHighlight, setHospitalGeneralDropHighlight] = useState(false);
	const generalDropHighlightRef = useRef(false);

	useEffect(() => {
		hoveredStandaloneRef.current = hoveredStandalone;
	}, [hoveredStandalone]);

	useEffect(() => {
		const draggingFromCategory =
			isLayoutMode &&
			(draggedCardIdRef.current || draggedCardId) &&
			dragSource &&
			dragSource !== "standalone";

		if (!draggingFromCategory) {
			generalDropHighlightRef.current = false;
			setHospitalGeneralDropHighlight(false);
			return;
		}

		const updateHighlight = (clientX, clientY) => {
			const next = pointerOverHospitalRootStandaloneArea({ x: clientX, y: clientY });
			if (next !== generalDropHighlightRef.current) {
				generalDropHighlightRef.current = next;
				setHospitalGeneralDropHighlight(next);
			}
		};

		const onMove = (e) => {
			if (e.touches?.[0]) {
				updateHighlight(e.touches[0].clientX, e.touches[0].clientY);
			} else if (typeof e.clientX === "number") {
				updateHighlight(e.clientX, e.clientY);
			}
		};

		const clear = () => {
			generalDropHighlightRef.current = false;
			setHospitalGeneralDropHighlight(false);
		};

		document.addEventListener("mousemove", onMove, true);
		document.addEventListener("touchmove", onMove, { passive: true, capture: true });
		document.addEventListener("mouseup", clear, true);
		document.addEventListener("touchend", clear, true);
		return () => {
			document.removeEventListener("mousemove", onMove, true);
			document.removeEventListener("touchmove", onMove, { capture: true });
			document.removeEventListener("mouseup", clear, true);
			document.removeEventListener("touchend", clear, true);
			clear();
		};
	}, [isLayoutMode, draggedCardId, dragSource]);

	// Fix 3: Continuous pointer tracking during category drag for reliable hit-testing.
	//
	// Also drives the live drop-zone highlight (`hoveredCategoryId` / `hoveredStandalone`)
	// via geometric hit-testing. We can't rely on each CategoryBox's `onMouseEnter` /
	// `onMouseLeave` alone because with layout-mode zoom (`transform: scale(0.76)`) and
	// the source category's drag-time styling (frozen Paper minHeight, overflow:visible,
	// elevated z-index on the dragging cell), the synthetic mouseenter/leave ordering
	// becomes unreliable during fast pointer moves — the highlight gets stuck on a
	// previously hovered category while the card visually tracks the real cursor.
	// Resolving the category from `elementFromPoint` on every mousemove keeps the
	// highlight locked to wherever the cursor actually is, regardless of React's
	// mouseenter/leave commit order.
	useEffect(() => {
		if (!isLayoutMode || !draggedCardId) return;

		const resolveHoverTargets = (x, y) => {
			if (typeof x !== "number" || typeof y !== "number") return;
			// Require the real cursor to lie inside the category Paper rect — see
			// `resolveHospitalCategoryIdUnderPointer` (charts/cards with overflow:visible
			// must not steal the category from the panel below).
			const resolvedCategoryId = resolveHospitalCategoryIdUnderPointer(x, y);
			const overStandalone =
				!resolvedCategoryId && pointerOverHospitalRootStandaloneArea({ x, y });

			setHoveredCategoryId((prev) => (prev === resolvedCategoryId ? prev : resolvedCategoryId));
			setHoveredStandalone((prev) => (prev === overStandalone ? prev : overStandalone));
		};

		// While the cursor sits in the auto-scroll trigger zone (top/bottom edge),
		// skip the heavy hover resolution. This app uses React 17 (legacy
		// `ReactDOM.render`), so renders are synchronous and any state change here
		// blocks the main thread — including the auto-scroll's own rAF tick. The
		// user isn't deciding a drop target while at the edge anyway; they're
		// positioning. The drop handler re-resolves the target from the release
		// point geometrically, so dropping while still in the zone is unaffected.
		const AUTOSCROLL_ZONE_PX = 160;
		const inAutoScrollZone = (y) => {
			if (typeof y !== "number" || typeof window === "undefined") return false;
			return y < AUTOSCROLL_ZONE_PX || y > window.innerHeight - AUTOSCROLL_ZONE_PX;
		};

		const track = (e) => {
			const clientX = e.touches?.[0]?.clientX ?? e.clientX;
			const clientY = e.touches?.[0]?.clientY ?? e.clientY;
			if (typeof clientX !== "number" || typeof clientY !== "number") return;
			lastPointerRef.current = { x: clientX, y: clientY, timestamp: Date.now() };
			if (inAutoScrollZone(clientY)) return;
			resolveHoverTargets(clientX, clientY);
		};
		// Capture phase so we still see moves even if an intermediate handler calls
		// stopPropagation (rare during nested RGL drags).
		document.addEventListener("mousemove", track, { passive: true, capture: true });
		document.addEventListener("touchmove", track, { passive: true, capture: true });
		return () => {
			document.removeEventListener("mousemove", track, true);
			document.removeEventListener("touchmove", track, true);
		};
	}, [isLayoutMode, draggedCardId]);

	useEffect(() => {
		return () => {
			if (dropFlashTimeoutRef.current) {
				clearTimeout(dropFlashTimeoutRef.current);
			}
		};
	}, []);

	// Get auth user for super user check
	const authUser = useSelector((state) => state.auth);
	const isSuperUser = authUser?.role?.slug === AUTH_ROLES.SUPER;

	// Use the sync preference hook
	const {
		syncPreference,
		loading: syncLoading,
		error: syncError,
		isSuperUser: hookIsSuperUser,
		toggleSyncPreference,
		refetch: refetchSyncPreference
	} = useSyncPreference(PAGE_TYPE.HOSPITAL);

	// Toast notification state
	const [toastNotification, setToastNotification] = useState({
		open: false,
		type: 'success',
		title: '',
		message: '',
	});

	// AI Chat state
	const [aiChatOpen, setAiChatOpen] = useState(false);
	const [aiChatUnreadCount, setAiChatUnreadCount] = useState(0);
	const [aiChatMinimized, setAiChatMinimized] = useState(false);
	const [aiConversationId, setAiConversationId] = useState(null);
	const [aiContextPreloaded, setAiContextPreloaded] = useState(false);
	// const [aiVectorStoreId, setAiVectorStoreId] = useState(null); // disabled: new agent API does not use vector stores

	// Share Report hook
	const {
		shareReportState,
		users,
		availableIntegrations,
		handleOnClickShareReport,
		handleCloseShareReport,
		handleShareReport,
	} = useShareReport({
		downloadPdf,
		generateExcel: downloadExcel, // Pass Excel generator for chart dialogs
		reportData: {
			cardFilter,
			filter,
			dbData,
			filterListData,
		},
		pageType: PAGE_TYPE.HOSPITAL,
	});

	// Check AI Chat access
	const { hasAccess: hasAiChatAccess, loading: aiChatAccessLoading } = useAiChatAccess();

	// Helper function to generate cache key for vector store ID
	// Key includes: page type + date range + facility IDs (sorted for consistency)
	// const getVectorStoreCacheKey = useCallback(() => {
	// 	if (!filter?.startDate || !filter?.endDate || !activeFacilities?.length) {
	// 		return null;
	// 	}
	// 	const sortedFacilityIds = [...activeFacilities].sort().join(',');
	// 	return `hospital_vector_store_${filter.startDate}_${filter.endDate}_${sortedFacilityIds}`;
	// }, [filter?.startDate, filter?.endDate, activeFacilities]);

	// Vector store cache restore — disabled (new agent API does not use vector stores)
	/*
	useEffect(() => {
		const cacheKey = getVectorStoreCacheKey();
		if (cacheKey) {
			const cachedVectorStoreId = localStorage.getItem(cacheKey);
			if (cachedVectorStoreId) {
				setAiVectorStoreId(cachedVectorStoreId);

				// Re-register restored vector store ID for cleanup tracking
				registerVectorStoreId(cachedVectorStoreId, 'hospital');
			}
		}
	}, [getVectorStoreCacheKey]);
	*/

	// AI Census Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiCensusActionsService.initialize(dispatch, () => ({
			common: { percentageBy, customPercentageLabel, customePercentages },
			hospital: { dbData },
			dashboardData: { isOnlyHospitalDashboard }
		}));
	}, [dispatch, percentageBy, customPercentageLabel, customePercentages, dbData, isOnlyHospitalDashboard]);
	*/

	// AI Date Suggestions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiDateSuggestionsService.initialize(dispatch, () => ({}));

		// Set validation context for date suggestions
		const validationContext = {
			currentFilter: filter,
			censusDate: null, // This would come from DateFilterComponent
			pauseDate: null,  // This would come from DateFilterComponent
			firstAndLastDate: null, // This would come from DateFilterComponent
			activeFacilities: activeFacilities
		};

		aiDateSuggestionsService.setValidationContext(validationContext);
	}, [dispatch, filter, activeFacilities]);
	*/

	const { updateDashboard } = useDashboard();

	const isAllowReturnCard = useMemo(() => {
		if (isFullAccess()) return true;

		const selectedTab = selectedTabAccess();
		return !isOnlyHospitalOrTransfer(selectedTab);
	}, []);

	// Layout management functions
	const generateDefaultLayout = useCallback(() => {
		const layout = [];
		let position = 0;

		// Follow the exact same sequence as cardData
		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DCER_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.DCER_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DCER_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.INSURANCE_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.INSURANCE_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.INSURANCE_DATA),
				position: position++,
			});
		}

		if ((isAllowReturnCard && _.includes(hospitalCards, HOSPITAL_CARDS_TYPE.RETURNS_DATA)) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.RETURNS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.RETURNS_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.FLOORS_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.FLOORS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.FLOORS_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DOCTOR_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.DOCTOR_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DOCTOR_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DAYS_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.DAYS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DAYS_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DX_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.DX_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DX_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.SHIFT_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.SHIFT_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.SHIFT_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.NURSE_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.NURSE_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.NURSE_DATA),
				position: position++,
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.HOSPITAL_DATA) || isMobile) {
			layout.push({
				id: HOSPITAL_CARDS_TYPE.HOSPITAL_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.HOSPITAL_DATA),
				position: position++,
			});
		}

		// Add dynamic cards to the default layout
		if (dynamicCards?.length > 0) {
			dynamicCards.forEach((ele) => {
				if (_.includes(hospitalCards, ele.accessor) || isMobile) {
					layout.push({
						id: getDynamicCardLayoutId(ele.accessor),
						width: 4, // Default width for dynamic cards
						position: position++,
					});
				}
			});
		}

		// Add custom tab cards to the default layout
		if (patientList?.customTabs?.length > 0) {
			patientList.customTabs.forEach((ele) => {
				if (_.includes(hospitalCards, ele.accessor) || isMobile) {
					layout.push({
						id: getCustomTabCardLayoutId(ele.accessor),
						width: 4, // Default width for custom tab cards
						position: position++,
					});
				}
			});
		}

		return layout;
	}, [hospitalCards, dynamicCards, patientList?.customTabs, isAllowReturnCard, isMobile]);

	const migrateLayout = useCallback((layout) => {
		if (!layout || (Array.isArray(layout) && layout.length === 0)) {
			return ensureHospitalRootOrder({
				version: '3.0',
				standalone: generateDefaultLayout().map(c => ({ ...c, gridH: 24 })),
				categories: [],
			});
		}
		if (Array.isArray(layout)) {
			return ensureHospitalRootOrder({
				version: '3.0',
				standalone: layout.map(c => ({ ...c, gridH: c.gridH || 24 })),
				categories: [],
			});
		}
		if (layout?.version === '2.0') {
			const generalCat = layout.categories.find(c => c.id === 'cat_general');
			const standardCategories = layout.categories.filter(c => c.id !== 'cat_general');
			return ensureHospitalRootOrder({
				version: '3.0',
				standalone: generalCat ? generalCat.cards.map(c => ({ ...c, gridH: c.gridH || 24 })) : [],
				categories: standardCategories.map(cat => ({
					...cat,
					gridH: cat.gridH || 94,
					cards: (cat.cards || []).map(c => ({ ...c, gridH: c.gridH || 24 }))
				})),
			});
		}
		// v3+: if nothing is stored inside categories, treat as "no category layout" — show all cards in general (standalone).
		const categories = layout.categories || [];
		const standalone = layout.standalone || [];
		const hasCategoryWithCards = categories.some(
			(cat) => Array.isArray(cat.cards) && cat.cards.length > 0
		);
		if (!hasCategoryWithCards) {
			const merged = [];
			const seen = new Set();
			const pushCard = (c) => {
				if (c && c.id != null && !seen.has(c.id)) {
					seen.add(c.id);
					merged.push({ ...c, gridH: c.gridH || 24 });
				}
			};
			standalone.forEach(pushCard);
			categories.forEach((cat) => (cat.cards || []).forEach(pushCard));
			if (merged.length === 0) {
				return ensureHospitalRootOrder({
					version: '3.0',
					standalone: generateDefaultLayout().map((c) => ({ ...c, gridH: 24 })),
					categories: [],
				});
			}
			return ensureHospitalRootOrder({
				...layout,
				version: layout.version || '3.0',
				categories: [],
				standalone: merged,
				rootOrder: undefined,
			});
		}
		return ensureHospitalRootOrder(layout);
	}, [generateDefaultLayout]);

	const patchHospitalLayoutBase = useCallback(
		(base) => {
			if (!base) return base;
			const normalized = normalizeHospitalLayoutCardIds(base, dynamicCards, patientList?.customTabs);
			return augmentHospitalLayoutWithSelectedCards(
				normalized,
				hospitalCards,
				dynamicCards,
				patientList?.customTabs
			);
		},
		[hospitalCards, dynamicCards, patientList?.customTabs]
	);

	const getCurrentLayout = useCallback(() => {
		const base = isLayoutMode && tempLayout?.version ? tempLayout : migrateLayout(hospitalLayout);
		const patched = patchHospitalLayoutBase(base);
		return ensureHospitalRootOrder({
			version: patched?.version || '3.0',
			standalone: patched?.standalone || [],
			categories: patched?.categories || [],
			rootOrder: patched?.rootOrder,
		});
	}, [tempLayout, hospitalLayout, isLayoutMode, migrateLayout, patchHospitalLayoutBase]);


	// AI Date Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		const validationContext = {
			currentFilter: filter,
			activeFacilities: activeFacilities
		};

		// Create a filter update handler that triggers date refresh (same as passed to HospitalHeader)
		const handleFilterUpdateForAI = () => setIsDateUpdated(true);

		aiDateActionsService.initialize(validationContext, updateDashboard, handleFilterUpdateForAI);
	}, [filter, activeFacilities, updateDashboard]);
	*/

	// Vector store invalidate-on-context-change — disabled (new agent API does not use vector stores)
	/*
	useEffect(() => {
		const cacheKey = getVectorStoreCacheKey();
		const previousCacheKey = sessionStorage.getItem('hospital_vector_store_cache_key');

		// If context changed (date range or facilities), clear old cache and vector store
		if (previousCacheKey && previousCacheKey !== cacheKey) {
			// Clear old cached vector store ID from localStorage
			if (previousCacheKey) {
				localStorage.removeItem(previousCacheKey);
			}

			// Clear vector store ID - forces new vector store creation with fresh data
			setAiVectorStoreId(null);

			// Clear conversation ID - starts fresh conversation with new context
			setAiConversationId(null);

		}

		// Update stored cache key
		if (cacheKey) {
			sessionStorage.setItem('hospital_vector_store_cache_key', cacheKey);
		}
	}, [getVectorStoreCacheKey]);
	*/


	const getDynamicTab = useCallback(async (page) => {
		let query = { page, forType: 'transfer', forTransferType: ["hospitalTransfer"], isCustom: true };
		const res = await getQuestionsData(query);

		let dynamicCards = [];
		let defaultCardTabs = [];
		if (res && res.length > 0) {
			const grouped = _.groupBy(res, 'isDefaultCard');
			defaultCardTabs = grouped.true || [];
			dynamicCards = [
				...(grouped.false || []),
				...(grouped.undefined || [])
			];
		}
		dispatch(setDefaultCardEdited(defaultCardTabs));
		dispatch(setDynamicCards(dynamicCards));
	}, [dispatch]); // Add dispatch to the dependency array

	// Check for openFrom=mobile parameter and set isDateUpdated
	useEffect(() => {
		const openFrom = searchParams.get('openFrom');
		if (openFrom === 'mobile') {
			setIsDateUpdated(true);
		}
	}, [searchParams]);

	// Page-specific notifications for Hospital page
	const {
		shareNotifications,
		showShareDialog,
		handleNotificationResponse,
		handleViewTab,
		handleCloseShareDialog
	} = usePageNotifications(PAGE_TYPE.HOSPITAL);

	useEffect(() => {
		updateDashboard({
			dbData,
			page: PAGE_TYPE.HOSPITAL,
			dbDataComparison,
			isOnlyHospitalDashboard,
			filter
		});
	}, [dbData, updateDashboard, dbDataComparison, isOnlyHospitalDashboard, filter]);



	useEffect(() => {
		if (selectedAccount?._id) {
			getDynamicTab(PAGE_TYPE.HOSPITAL);
		}
	}, [selectedAccount?._id, getDynamicTab]);

	// Load saved layout from database on component mount
	useEffect(() => {
		const loadLayoutFromDatabase = async () => {
			try {
				const rawLayout = await fetchSavedLayout(currentLayoutType);
				if (rawLayout != null && typeof rawLayout === "object") {
					const isFallback = rawLayout.isFallbackToDefault;
					const normalizedLayout = ensureHospitalRootOrder(
						patchHospitalLayoutBase(migrateLayout(rawLayout))
					);
					dispatch(setHospitalLayout(normalizedLayout));
					setCollapsedCategoryIds(getCollapsedIdsFromLayout(normalizedLayout, isFallback));
				}
			} catch (error) {
				console.error("Error loading layout from database:", error);
				// Continue with default layout if database load fails
			}
		};

		// Only load from database if no layout is already in Redux
		if (!hospitalLayout || hospitalLayout.length === 0) {
			loadLayoutFromDatabase();
		}
	}, [hospitalLayout, dispatch, currentLayoutType, fetchSavedLayout, migrateLayout, patchHospitalLayoutBase]);

	useEffect(() => {
		if (hasInitializedCollapsedStateRef.current) return;
		if (isLayoutMode) return;
		const categories = Array.isArray(hospitalLayout?.categories) ? hospitalLayout.categories : [];
		if (categories.length === 0) return;
		setCollapsedCategoryIds(getCollapsedIdsFromLayout(hospitalLayout, hospitalLayout.isFallbackToDefault));
		hasInitializedCollapsedStateRef.current = true;
	}, [hospitalLayout, isLayoutMode]);

	const handleOnclickCard = useCallback(
		(value, total, mainTotal = null) => {
			batch(() => {
				if (transferType && transferType === value) {
					dispatch(setTransferType(null));
					dispatch(setMainTotal(mainTotal));
				} else {
					dispatch(setTransferType(value));
					dispatch(setMainTotal(total));
				}
			});
		},
		[dispatch, transferType]
	);

	// Utility function to generate cache key from filter parameters (including accountId)
	const generateCacheKey = (filterData, forComparison, type) => {
		const cleanedData = JSON.parse(
			JSON.stringify(filterData, (_key, value) => (value == null ? undefined : value))
		);

		// Sort facilityIds array to ensure consistent cache keys regardless of selection order
		// This is critical when multiple facilities are selected - same facilities in different order should generate same key
		if (cleanedData.facilityIds && Array.isArray(cleanedData.facilityIds)) {
			cleanedData.facilityIds = [...cleanedData.facilityIds].sort((a, b) => {
				const aStr = String(a);
				const bStr = String(b);
				return aStr.localeCompare(bStr);
			});
		}

		const accountId = authUser?.accountId || null;
		const cacheKey = JSON.stringify({ data: cleanedData, type, forComparison, accountId });

		return cacheKey;
	};

	const getAllDataCount = async (filter, forComparison, skipCache = false) => {
		setFilterListData({ ...DEFAULT_FILTER_PAGE });
		setPatientList([]);
		setPageConverterPatientSource(null);
		setLoading(true);

		const currentRequest = uniqueId();
		if (forComparison) {
			fetchRequestRefComparison.current = currentRequest;
		} else {
			fetchRequestRef.current = currentRequest;
		}
		activeRequestRef.current = currentRequest;
		// const filterData = _.omit(filter, ["rangeFilter"]);

		try {
			// Generate cache keys - include activeFacilities to ensure unique cache per facility selection
			const mainFilterWithFacilities = { ...filter, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, 'main');
			const comparisonFilter = rangesSet ? {
				...filterComparison,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKey = comparisonFilter ? generateCacheKey(comparisonFilter, true, 'comparison') : null;

			// Check cache for main result - skip cache if skipCache flag is true
			let mainResult = skipCache ? null : cachedMainResults[mainCacheKey];
			let comparisonResult = skipCache ? null : (comparisonCacheKey ? cachedComparisonResults[comparisonCacheKey] : null);

			// Track if data came from cache (both main and comparison)
			const isFromCache = !!mainResult || !!comparisonResult;
			setIsDataFromCache(isFromCache);

			// Fetch from API if not in cache
			const fetchPromises = [];

			if (!mainResult) {
				fetchPromises.push(getAllPatientCount(filter, false, 'main'));
			} else {
				fetchPromises.push(Promise.resolve(mainResult));
			}

			if (rangesSet) {
				if (!comparisonResult) {
					fetchPromises.push(getAllPatientCount(comparisonFilter, true, 'comparison'));
				} else {
					fetchPromises.push(Promise.resolve(comparisonResult));
				}
			} else {
				fetchPromises.push(Promise.resolve(null));
			}

			const [fetchedMainResult, fetchedComparisonResult] = await Promise.all(fetchPromises);

			// Update main result - use cached if available, otherwise use fetched and cache it
			if (!mainResult) {
				mainResult = fetchedMainResult;
				// Clear old cache before saving new cache
				dispatch(clearCachedResults('main'));
				// Save to cache
				if (mainResult) {
					dispatch(setCachedMainResult({ filterKey: mainCacheKey, result: mainResult }));
				}
			} else {
				mainResult = fetchedMainResult; // Use cached result (resolved from promise)
			}

			// Update comparison result - use cached if available, otherwise use fetched and cache it
			if (rangesSet) {
				if (!comparisonResult) {
					comparisonResult = fetchedComparisonResult;
					// Clear old cache before saving new cache
					dispatch(clearCachedResults('comparison'));
					// Save to cache
					if (comparisonResult) {
						dispatch(setCachedComparisonResult({ filterKey: comparisonCacheKey, result: comparisonResult }));
					}
				} else {
					comparisonResult = fetchedComparisonResult; // Use cached result (resolved from promise)
				}
			}

			if (activeRequestRef.current !== currentRequest) return;

			if (mainResult && mainResult.list) {
				setPatientList(mainResult);
				await updateTotalToDBFilter(mainResult);
			}

			if (comparisonResult && comparisonResult.list) {
				dispatch(setPatientListComparison(comparisonResult));
				await updateTotalToDBFilterComparison(comparisonResult, transferType);
			} else {
				dispatch(setPatientListComparison([]));
			}
		} catch (e) {
			if (activeRequestRef.current !== currentRequest) return;

			if (e?.message !== "canceled") {
				setLoading(false);

				if (hospitalLoading) {
					dispatch(setHospitalLoading(false));
				}
			}
		} finally {
			if (activeRequestRef.current === currentRequest) {
				setLoading(false);

				if (hospitalLoading) {
					dispatch(setHospitalLoading(false));
				}
			}
		}
	};

	const { setPathWithParams } = useSetParamToURL();

	useEffect(() => {
		const handlePopState = () => {
			// When back button is pressed, redirect to the desired page
			setPathWithParams("/home");
		};
		window.addEventListener('popstate', handlePopState);
		// Cleanup: remove event listener when effect is cleaned up or `isOnlyHospitalDashboard` changes
		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [setPathWithParams, isOnlyHospitalDashboard]);

	useEffect(() => {
		async function fetchMyAPI(filter, skipCache = false) {
			// Check cache synchronously before resetting locked values
			// Use the same cache key generation logic as getAllDataCount
			const mainFilterWithFacilities = { ...filter, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, 'main');

			// Skip cache check if skipCache flag is true
			const hasMainCache = skipCache ? false : !!cachedMainResults[mainCacheKey];

			// Only reset locked values if data is NOT from cache
			if (!hasMainCache) {
				batch(() => {
					dispatch(setLockTotal(null));
					dispatch(setLockedTotalBy(null));
				});
			}

			await getAllDataCount(filter, false, skipCache);
		}

		const isInitialRender = isInitialDataFetchRef.current;

		if (!skipMainFetch && isDateUpdated && filter && filter.startDate && activeFacilityLocalStorage && activeFacilities.length > 0) {
			const mainFilterWithFacilities = { ...filter, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, 'main');
			const shouldSkipCache = !isInitialRender && prevIsCustomTabAddedRef.current !== isCustomTabAdded;
			const requestSignature = `${mainCacheKey}|customTabAdded:${String(isCustomTabAdded)}|skipCache:${String(
				shouldSkipCache
			)}`;

			// Guard against rerender-driven effect runs where none of the effective
			// fetch inputs changed (common during layout-mode toggles).
			if (lastMainFetchSignatureRef.current === requestSignature) {
				return;
			}
			lastMainFetchSignatureRef.current = requestSignature;

			// Skip cache whenever custom-tab refresh flag changes, not just when it is true.
			fetchMyAPI({ ...filter, facilityIds: activeFacilities }, shouldSkipCache);
			prevIsCustomTabAddedRef.current = isCustomTabAdded;

			// Mark that this useEffect has run at least once
			if (isInitialDataFetchRef.current) {
				isInitialDataFetchRef.current = false;
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		// eslint-disable-next-line react-hooks/exhaustive-deps
		activeFacilityLocalStorage,
		filter,
		isCustomTabAdded,
		isDateUpdated
	]);

	useEffect(() => {

		async function fetchMyAPI(filter) {
			// Check cache synchronously before resetting locked values
			// Use the same cache key generation logic as getAllDataCount for comparison
			const comparisonFilter = rangesSet ? {
				...filterComparison,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKey = comparisonFilter ? generateCacheKey(comparisonFilter, true, 'comparison') : null;
			const hasComparisonCache = comparisonCacheKey ? !!cachedComparisonResults[comparisonCacheKey] : false;

			// Only reset locked values if comparison data is NOT from cache
			if (!hasComparisonCache) {
				batch(() => {
					dispatch(setLockTotal(null));
					dispatch(setLockedTotalBy(null));
				});
			}

			const filterData = _.omit(filter, ["defaultComparison"]);
			await getAllDataCount(filterData, true);
		}
		if (isDateUpdated && filter && filter.startDate && activeFacilityLocalStorage && activeFacilities.length > 0) {
			const comparisonFilterForSignature = rangesSet ? {
				...filterComparison,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKeyForSignature = comparisonFilterForSignature
				? generateCacheKey(comparisonFilterForSignature, true, 'comparison')
				: '__no_comparison_cache_key__';
			const requestSignature = `${comparisonCacheKeyForSignature}|rangesSet:${String(
				rangesSet
			)}|start:${comparisonRanges?.[0]?.startDate || ''}|end:${comparisonRanges?.[0]?.endDate || ''}`;

			// Guard against rerender-driven effect runs where none of the effective
			// comparison fetch inputs changed.
			if (lastComparisonFetchSignatureRef.current === requestSignature) {
				return;
			}
			lastComparisonFetchSignatureRef.current = requestSignature;

			fetchMyAPI({ ...filter, facilityIds: activeFacilities });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterComparison, isDateUpdated, comparisonRanges]);

	useEffect(() => {
		if (isResetFilter) {
			updateTotalToDBFilter(patientList);
			dispatch(setResetFilter(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isResetFilter]);

	useEffect(() => {
		updateTotalToDBFilter(patientList);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mainNumPercentage, lockedTotal, projectionDays, percentageAgainst]);

	useEffect(() => {
		updateTotalToDBFilter(patientList);
		rangesSet && updateTotalToDBFilterComparison(patientListComparison, transferType);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [transferType, projectionDays]);


	const updateTotalToDBFilter = async (res) => {
		const latestListData = await updateFilterListData(cardFilter, transferType, res, cardFilter.priorityData, false, defaultCardEdited);
		const { pageConverterFilteredPatients, ...filterListPatch } = latestListData;
		setFilterListData((prevState) => ({
			...prevState,
			...filterListPatch,
		}));
		setPageConverterPatientSource(Array.isArray(pageConverterFilteredPatients) ? pageConverterFilteredPatients : []);
		persistHospitalPageConverterCardContext({
			pageType: PAGE_TYPE.HOSPITAL,
			transferType,
			cardFilter,
			priorityData: cardFilter?.priorityData ?? [],
		});

		// Pre-load AI conversation with context data for faster responses
		await preloadAIConversation();
	};

	const updateTotalToDBFilterComparison = async (res, transferType) => {
		const latestListData = await updateFilterListData(
			cardFilterComparison,
			transferType,
			res,
			cardFilterComparison.priorityData,
			true,
			defaultCardEdited
		);
		const { pageConverterFilteredPatients: _omitPc, ...comparisonPatch } = latestListData;
		dispatch(setFilterListDataComparison({ ...filterListDataComparison, ...comparisonPatch }));
	};

	const handleToggle = useCallback(
		async ({ item, itemComparison, type: typeData, setSpecialNumberFlag = true, cardTitle = null, question, isSpacialItem = false }) => {
			triggerFilterTutorial();
			if (item) {
				let type = typeData;
				if (isSpacialItem) {
					type = `${type}_spacial`;
				}
				// For custom tabs (both customTab and combineTab) with duplicate titles, use composite key (accessor__uniqueKey) instead of item._id
				// This allows multiple selections of the same dashboard
				const value = question?.compositeKey || item._id;

				// For composite keys (both customTab and combineTab), get patientIds from the specific totalByPage entry using uniqueKey
				// This ensures we use the correct patientIds for each specific item, not the mutated data[0]
				// For combineTab: always has totalByPage with entries like hospital_0, admission_3, etc.
				// For customTab: may or may not have totalByPage depending on structure
				let patientIds = item?.patientIds ?? [];
				if (question?.compositeKey && question?.uniqueKey && item?.totalByPage) {
					// Get patientIds from the specific totalByPage entry for this uniqueKey
					// Works for both combineTab (always has totalByPage) and customTab (if it has totalByPage)
					const specificItem = item.totalByPage[question.uniqueKey];
					if (specificItem && specificItem.patientIds) {
						patientIds = specificItem.patientIds;
					}
				}
				// If no totalByPage or no specific entry found, patientIds already set to item?.patientIds above

				// Get patientIds from comparison data for comparison filter
				// Use itemComparison if provided, otherwise find it in filterListDataComparison
				// This works for both customTab and combineTab
				let patientIdsComparison = [];
				if (rangesSet) {
					let comparisonItem = itemComparison;

					// If itemComparison not provided, try to find it
					// Use question?.accessor if available, otherwise fallback to type (which is the accessor)
					const accessorToUse = question?.accessor || type;
					if (!comparisonItem && filterListDataComparison && accessorToUse) {
						// Try to find by accessor and id/_id match first
						comparisonItem = filterListDataComparison[accessorToUse]?.find(
							(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
						);

						// If not found by id match, try using the first item from the accessor array
						if (!comparisonItem) {
							comparisonItem = filterListDataComparison[accessorToUse]?.[0];
						}
					}

					if (comparisonItem) {
						// For composite keys (both customTab and combineTab), get patientIds from the specific totalByPage entry in comparison data
						// This is the most important part - we need the specific entry's patientIds, not the main item's
						// For combineTab: always has totalByPage, so we get from specific entry
						// For customTab: if it has totalByPage, get from specific entry; otherwise use main item's patientIds
						if (question?.compositeKey && question?.uniqueKey && comparisonItem?.totalByPage) {
							const specificComparisonItem = comparisonItem.totalByPage[question.uniqueKey];
							if (specificComparisonItem && specificComparisonItem.patientIds) {
								patientIdsComparison = specificComparisonItem.patientIds;
							} else {
								// Fallback to main comparison item's patientIds if specific entry not found
								patientIdsComparison = comparisonItem?.patientIds ?? [];
							}
						} else {
							// For non-composite keys or customTab without totalByPage, use the main comparison item's patientIds
							patientIdsComparison = comparisonItem?.patientIds ?? [];
						}
					}
				}

				const filtersItem = { ...cardFilter };
				if (filtersItem[type] === undefined) {
					filtersItem[type] = [];
				}
				const filterData = filtersItem[type];

				// Check if this specific composite key is already selected
				// For composite keys, check for the composite key; for regular items, check for item._id
				let currentIndex = -1;
				if (question?.compositeKey) {
					// Check for composite key first
					currentIndex = filterData.indexOf(question.compositeKey);
					// If not found and we have an old format entry (item._id), we'll handle it below
				} else {
					// For non-composite keys, check normally
					currentIndex = filterData.indexOf(value);
				}

				const newChecked = filterData ? [...filterData] : [];
				let isRemoveIds = false;
				let isReplaceIds = false;
				if (currentIndex === -1) {
					// Adding new selection - push the composite key or item._id
					newChecked.push(value);
					// If we're adding a composite key and there's an old format entry (item._id), remove it
					// This ensures we don't have both old and new format in the array
					if (question?.compositeKey) {
						const oldFormatIndex = newChecked.indexOf(item._id);
						if (oldFormatIndex !== -1) {
							newChecked.splice(oldFormatIndex, 1);
						}
					}
				} else {
					// Removing selection
					isRemoveIds = question?.isCustom ? true : false;
					newChecked.splice(currentIndex, 1);

					// For composite keys (both customTab and combineTab), when unselecting, recalculate patientIds from all remaining selected items
					// This ensures we have the correct combined patientIds from all remaining selections
					if (question?.compositeKey && newChecked.length > 0) {
						// Recalculate patientIds from all remaining selected composite keys
						// Works for both combineTab (has totalByPage) and customTab (may or may not have totalByPage)
						const remainingPatientIds = [];
						const remainingPatientIdsComparison = [];

						// Get comparison item for recalculating comparison patientIds
						// Use question?.accessor if available, otherwise fallback to type (which is the accessor)
						const accessorToUseForRecalc = question?.accessor || type;
						let comparisonItem = itemComparison;
						if (!comparisonItem && filterListDataComparison && accessorToUseForRecalc) {
							comparisonItem = filterListDataComparison[accessorToUseForRecalc]?.find(
								(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
							);
							if (!comparisonItem) {
								comparisonItem = filterListDataComparison[accessorToUseForRecalc]?.[0];
							}
						}

						newChecked.forEach(selectedKey => {
							// Check if it's a composite key (format: accessor__uniqueKey)
							if (selectedKey.includes('__')) {
								const [, uniqueKey] = selectedKey.split('__');

								// For main data: get from totalByPage if it exists (combineTab or customTab with totalByPage)
								if (item?.totalByPage) {
									const specificItem = item.totalByPage[uniqueKey];
									if (specificItem && specificItem.patientIds) {
										remainingPatientIds.push(...specificItem.patientIds);
									}
								} else {
									// For customTab without totalByPage, use item.patientIds
									if (item.patientIds) {
										remainingPatientIds.push(...item.patientIds);
									}
								}

								// For comparison data: get from totalByPage if it exists
								if (rangesSet && comparisonItem) {
									if (comparisonItem?.totalByPage) {
										const specificComparisonItem = comparisonItem.totalByPage[uniqueKey];
										if (specificComparisonItem && specificComparisonItem.patientIds) {
											remainingPatientIdsComparison.push(...specificComparisonItem.patientIds);
										}
									} else {
										// For customTab without totalByPage, use comparisonItem.patientIds
										if (comparisonItem.patientIds) {
											remainingPatientIdsComparison.push(...comparisonItem.patientIds);
										}
									}
								}
							} else {
								// Old format - use item.patientIds
								if (item.patientIds) {
									remainingPatientIds.push(...item.patientIds);
								}
								// For comparison data
								if (rangesSet && comparisonItem?.patientIds) {
									remainingPatientIdsComparison.push(...comparisonItem.patientIds);
								}
							}
						});

						// Use union to combine and deduplicate patientIds from all remaining selections
						patientIds = _.union(remainingPatientIds);
						if (rangesSet) {
							patientIdsComparison = _.union(remainingPatientIdsComparison);
						}
						// Since we've recalculated, we should replace the entire patientIds array
						isReplaceIds = true;
						isRemoveIds = false;
					}
				}
				if (!isSpacialItem) {
					const [priorityData, priorityDataComparison] = await Promise.all([
						priorityFilter(
							cardFilter.priorityData,
							type,
							newChecked.length,
							cardTitle,
							question,
							patientIds,
							isRemoveIds,
							newChecked,
							isReplaceIds
						),
						rangesSet
							? priorityFilter(
								cardFilterComparison?.priorityData,
								type,
								newChecked.length,
								cardTitle,
								question,
								patientIdsComparison.length > 0 ? patientIdsComparison : patientIds,
								isRemoveIds,
								newChecked,
								isReplaceIds
							)
							: undefined,
					]);

					batch(() => {
						dispatch(setCardFilter({ [type]: newChecked, priorityData: priorityData }));
						rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked, priorityData: priorityDataComparison }));

						if (specialComparisonSet && !setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(false));
						} else if (!specialComparisonSet && !setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(true));
						}
						rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked, priorityData: priorityDataComparison }));
					});

					const [latestListData, latestListDataComparison] = await Promise.all([
						updateFilterListData({ ...cardFilter, [type]: newChecked }, transferType, patientList, priorityData, false, defaultCardEdited),
						rangesSet
							? updateFilterListData(
								{ ...cardFilterComparison, [type]: newChecked },
								transferType,
								patientListComparison,
								priorityDataComparison,
								true,
								defaultCardEdited
							)
							: undefined,
					]);

					const { pageConverterFilteredPatients: mainFilteredPatients, ...mainListPatch } = latestListData;
					setPageConverterPatientSource(Array.isArray(mainFilteredPatients) ? mainFilteredPatients : []);
					persistHospitalPageConverterCardContext({
						pageType: PAGE_TYPE.HOSPITAL,
						transferType,
						cardFilter: { ...cardFilter, [type]: newChecked, priorityData },
						priorityData: priorityData ?? [],
					});

					batch(async () => {
						setFilterListData((prevState) => {
							return { ...prevState, ...mainListPatch };
						});
						if (rangesSet) {
							const { pageConverterFilteredPatients: _c, ...comparisonPatch } = latestListDataComparison || {};
							const updatedFilterListData = await updateCurrentFilterListData(filterListDataComparison, comparisonPatch);
							await dispatch(setFilterListDataComparison({ ...filterListDataComparison, ...updatedFilterListData }));
						}
					});
				} else {
					batch(() => {
						dispatch(setCardFilter({ [type]: newChecked }));
						rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked }));

						if (specialComparisonSet && !setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(false));
						} else if (!specialComparisonSet && !setSpecialNumberFlag) {
							dispatch(setIsSpecialComparison(true));
						}
						rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked }));
					});
				}
			}
		},
		[
			cardFilter,
			rangesSet,
			cardFilterComparison,
			dispatch,
			specialComparisonSet,
			transferType,
			patientList,
			patientListComparison,
			filterListDataComparison,
			triggerFilterTutorial,
			defaultCardEdited
		]
	);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleToggleAll = async ({ items, type, cardTitle = null }) => {
		triggerFilterTutorial();

		const filtersItem = { ...cardFilter };
		if (filtersItem[type] === undefined) {
			filtersItem[type] = [];
		}
		const filterData = filtersItem[type];
		const itemIds = items.map((x) => x._id);
		const valuesAlreadyInFilterData = itemIds.every((x) => filterData.includes(x));
		let newChecked = [];
		if (valuesAlreadyInFilterData) {
			newChecked = filterData.filter((x) => !itemIds.some((y) => y === x));
		} else {
			newChecked = [...filterData, ...itemIds];
		}

		const [priorityData, priorityDataComparison] = await Promise.all([
			priorityFilter(cardFilter.priorityData, type, newChecked.length, cardTitle),
			rangesSet ? priorityFilter(cardFilterComparison?.priorityData, type, newChecked.length, cardTitle) : undefined,
		]);
		batch(() => {
			dispatch(setCardFilter({ [type]: newChecked, priorityData: priorityData }));
			rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked, priorityData: priorityDataComparison }));

			rangesSet && dispatch(setCardFilterComparison({ [type]: newChecked, priorityData: priorityDataComparison }));
		});
		const [latestListData, latestListDataComparison] = await Promise.all([
			updateFilterListData({ ...cardFilter, [type]: newChecked }, transferType, patientList, priorityData, false, defaultCardEdited),
			rangesSet
				? updateFilterListData(
					{ ...cardFilterComparison, [type]: newChecked },
					transferType,
					patientListComparison,
					priorityDataComparison,
					true,
					defaultCardEdited
				)
				: undefined,
		]);

		const { pageConverterFilteredPatients: mainFilteredPatientsAll, ...mainListPatchAll } = latestListData;
		setPageConverterPatientSource(Array.isArray(mainFilteredPatientsAll) ? mainFilteredPatientsAll : []);
		persistHospitalPageConverterCardContext({
			pageType: PAGE_TYPE.HOSPITAL,
			transferType,
			cardFilter: { ...cardFilter, [type]: newChecked, priorityData },
			priorityData: priorityData ?? [],
		});

		setFilterListData((prevState) => {
			return { ...prevState, ...mainListPatchAll };
		});
		if (rangesSet) {
			const { pageConverterFilteredPatients: _cAll, ...comparisonPatchAll } = latestListDataComparison || {};
			const updatedFilterListData = await updateCurrentFilterListData(filterListDataComparison, comparisonPatchAll);
			await dispatch(setFilterListDataComparison(updatedFilterListData));
		}
	};

	// AI Filter Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		// Create a callback that triggers data refresh when filter is applied
		const onFilterApplied = () => {
			setIsDateUpdated(true);
		};

		aiFilterActionsService.initialize(
			dispatch,
			() => ({
				hospital: {
					filterListData,
					cardFilter,
					dynamicCards, // Pass dynamicCards so AI can access custom/dynamic filters
					patientList   // Pass patientList so AI can access customTabs
				}
			}),
			handleToggle,
			handleToggleAll,
			onFilterApplied
		);

	}, [dispatch, filterListData, cardFilter, dynamicCards, patientList, handleToggle, handleToggleAll]);
	*/


	// * added comparison
	const handleChartDialog = useCallback(
		async (title, type, relation = null, isTotalCard = false, defaultTab = null, question = null) => {

			let latestCardFilter = await updateChartFilterByPriority(cardFilter, type);

			let filterSelected =
				(cardFilter.priorityData.length > 0 && cardFilter.priorityData[0]["type"] !== type) ||
				transferType != null;
			let data = [];
			if (
				type === HOSPITAL_CARDS_TYPE.UNPLANNED ||
				type === HOSPITAL_CARDS_TYPE.PLANNED ||
				type === HOSPITAL_CARDS_TYPE.TOTAL
			) {
				filterSelected = false;
				data = [];
			} else {
				data = filterListData[type];
			}
			const { customRangeCombinedData } = processCustomRangeCombinedData(question, filterListData, type);

			// Normalize selectedFilterData for combineTab cards:
			// in the parent card, we store composite keys like `${accessor}__hospital_0`
			// but in the details dialog we use just the per-dashboard keys (`hospital_0`, `admission_3`, etc.)
			const rawSelectedFilterData = cardFilter[type] || [];
			const selectedFilterData =
				question?.customTab?.type === "combineTab" && Array.isArray(rawSelectedFilterData)
					? rawSelectedFilterData.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: rawSelectedFilterData;

			const filters = {
				facilityId: facilityIdFromHook,
				facilityIds: activeFacilities,
				cardFilter: latestCardFilter,
				selectedFilterData,
				type,
				filter,
				relation,
				transferType,
				filterSelected,
				facilityPercentage,
				lockedByFacility,
				lockedTotal,
				isCensusTotalLocked,
				isTotalCard,
				filterListData,
				defaultTab,
				question,
				cardTitle: title,
				customRangeCombinedData,
				// Pass the full patient list from the main Hospital page so Trend Mapping
				// can optionally use it (e.g. when Filter Mode = \"Remove All Filters\")
				// instead of relying only on dialog-level datasets.
				patientListFromPage: Array.isArray(patientList?.list) ? patientList.list : [],
			};

			dispatch(
				openDetailsDialog({
					isOpen: true,
					title,
					type,
					data: data.length > 0 ? data?.filter(item => !item?.isSpacialItem) : [],
					filters,
					dbData,
				})
			);

			// COMPARISON ANALOG ------>
			let latestCardFilterComparison = await updateChartFilterByPriority(cardFilterComparison, type);
			let filterSelectedComparison =
				(cardFilterComparison?.priorityData.length > 0 &&
					cardFilterComparison?.priorityData[0]["type"] !== type) ||
				transferType != null;
			let dataComparison = [];
			if (
				type === HOSPITAL_CARDS_TYPE.UNPLANNED ||
				type === HOSPITAL_CARDS_TYPE.PLANNED ||
				type === HOSPITAL_CARDS_TYPE.TOTAL
			) {
				filterSelectedComparison = false;
				dataComparison = [];
			} else {
				dataComparison = filterListDataComparison ? filterListDataComparison[type] : [];
			}
			const { customRangeCombinedData: customRangeCombinedDataComparison } = processCustomRangeCombinedData(question, filterListDataComparison, type);

			// Normalize comparison selectedFilterData for combineTab cards in the same way
			const rawSelectedFilterDataComparison = cardFilterComparison?.[type] || [];
			const selectedFilterDataComparison =
				question?.customTab?.type === "combineTab" && Array.isArray(rawSelectedFilterDataComparison)
					? rawSelectedFilterDataComparison.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: rawSelectedFilterDataComparison;

			const filtersComparison = {
				facilityId: activeFacilitiesComparison[0],
				facilityIds: activeFacilitiesComparison,
				cardFilter: latestCardFilterComparison,
				selectedFilterData: selectedFilterDataComparison,
				type,
				filter: filterComparison,
				relation,
				transferType: transferTypeComparison,
				filterSelected: filterSelectedComparison,
				facilityPercentage: facilityPercentageComparison,
				lockedByFacility: lockedByFacilityComparison,
				lockedTotal: lockedTotalComparison,
				isCensusTotalLocked: isCensusTotalLockedComparison,
				customRangeCombinedData: customRangeCombinedDataComparison
			};
			dispatch(
				openDetailsDialogComparison({
					isOpen: true,
					title,
					type,
					data: dataComparison,
					filters: filtersComparison,
				})
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			dispatch,
			filterListData,
			cardFilter,
			filter,
			filterListDataComparison,
			cardFilterComparison,
			filterComparison,
			filterListDataComparison,
		]
	);

	const handleClickTotal = useCallback(
		(total) => {
			batch(() => {
				dispatch(setTransferType(transferType === TYPES.ALL ? null : TYPES.ALL));
				dispatch(setMainTotal(total));
			});
		},
		[dispatch, transferType]
	);

	const getPriorityNumber = useCallback(
		(type) => {
			const idx = cardFilter.priorityData.findIndex((p) => p.type === type);
			return idx != null && idx !== -1 ? idx + 1 : null;
		},
		[cardFilter]
	);

	const hospitalHeaderPopoverDynamicCards = useMemo(
		() => [...(dynamicCards || []), ...(patientList?.customTabs || [])],
		[dynamicCards, patientList?.customTabs]
	);

	const hospitalDynamicTabDataByAccessor = useMemo(() => {
		const out = {};
		const layout = getCurrentLayout();
		const visit = (cards) => {
			if (!Array.isArray(cards)) return;
			for (const card of cards) {
				if (card?.component === "dynamic" && card?.data?.accessor != null) {
					out[card.data.accessor] = card.data;
				}
			}
		};
		visit(layout?.standalone);
		for (const cat of layout?.categories || []) {
			visit(cat?.cards);
		}
		return out;
	}, [getCurrentLayout]);

	const hospitalHeaderCardFilterPanelProps = useMemo(
		() => ({
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			cardFilter,
			filter,
			filterComparison,
			loading,
			loadingComparison,
			projectionDays,
			filterTotal,
			filterTotalComparison,
			dbData,
			dbDataComparison,
			specialComparisonSet,
			transferType,
			lockedTotalBy,
			getPriorityNumber,
			comparingAgainstDifferentFacility,
			dynamicCards: hospitalHeaderPopoverDynamicCards,
			hospitalDynamicTabDataByAccessor,
			percentageAgainst,
		}),
		[
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			cardFilter,
			filter,
			filterComparison,
			loading,
			loadingComparison,
			projectionDays,
			filterTotal,
			filterTotalComparison,
			dbData,
			dbDataComparison,
			specialComparisonSet,
			transferType,
			lockedTotalBy,
			getPriorityNumber,
			comparingAgainstDifferentFacility,
			hospitalHeaderPopoverDynamicCards,
			hospitalDynamicTabDataByAccessor,
			percentageAgainst,
		]
	);

	const renderHospitalCardFilterPopover = useCallback(
		({ dataKey, headerFilterPopoverOpen }) => (
			<HospitalHeaderCardFilterPanel
				dataKey={dataKey}
				headerFilterPopoverOpen={headerFilterPopoverOpen}
				{...hospitalHeaderCardFilterPanelProps}
			/>
		),
		[hospitalHeaderCardFilterPanelProps]
	);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleOnClickReport = async (type, title, isTotalCard = false, automaticallyReport = null, customData = null) => {
		try {
			if (automaticallyReport) {
				return await saveAutomaticReport({
					type,
					title,
					cardFilter,
					filter: {
						...filter,
						startDate: toSaveDate(filter.startDate),
						endDate: toSaveEndDate(filter.endDate),
					},
					dbData,
					page: PAGE_TYPE.HOSPITAL,
					filterListData,
					isTotalCard,
					automaticallyReport: { ...automaticallyReport, ...customData },
					transferType,
					lockedByFacility: lockedByFacility?.length > 0 ? lockedByFacility?.map(item => ({ facilityId: item.facilityId, _id: item._id })) : null,
					lockedTotal,
					lockedTotalBy,
					isCensusTotalLocked,
					lastADTDate,
					percentageBy,
				});
			} else {
				await downloadPdf({
					type,
					title,
					cardFilter,
					filter,
					dbData,
					page: PAGE_TYPE.HOSPITAL,
					filterListData,
					isTotalCard,
					customData
				});
			}
		} catch (error) {
			console.error("Error generating report:", error);
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					type: "error",
					label: "Failed to generate report. Please check if popups are blocked and try again.",
					id: "reportGenerationError",
				},
			});
		}
	};


	const handleOnClickReportGraph = async (graphData) => {
		if (graphData && graphData.automaticallyReport) {
			const graphDataUpdated = _.omit(graphData, ["chartData", "filterData", "tableElementRef", "buildingElementRef"]);
			const reportMeta = pickObjectByPaths(detailsDialog, REPORT_META_PATHS);

			const filterPaths = REPORT_META_PATHS.filter((path) => path.startsWith("filters.")).map((path) => path.replace("filters.", ""));
			const graphFiltersUpdated = pickObjectByPaths(graphDataUpdated?.filters, filterPaths);

			const graphDataSanitized = {
				...graphDataUpdated,
				filters: graphFiltersUpdated,
				detailsDialog: reportMeta,
			};

			return await saveAutomaticReport({
				type: graphData?.filters?.type,
				title: graphData?.automaticallyReport?.title,
				cardFilter,
				filter: {
					...filter,
					startDate: toSaveDate(filter.startDate),
					endDate: toSaveEndDate(filter.endDate),
				},
				dbData,
				page: PAGE_TYPE.HOSPITAL,
				filterListData,
				automaticallyReport: graphData?.automaticallyReport,
				transferType,
				lockedByFacility: lockedByFacility?.length > 0 ? lockedByFacility?.map(item => ({ facilityId: item.facilityId, _id: item._id })) : null,
				lockedTotal,
				lockedTotalBy,
				isCensusTotalLocked,
				lastADTDate,
				isGraphReport: true,
				graphData: graphDataSanitized,
				percentageBy,
			});
		} else {
			await downloadPdf({
				type: graphData?.filters?.type,
				cardFilter,
				filter,
				dbData,
				page: PAGE_TYPE.HOSPITAL,
				filterListData,
				isTotalCard: false,
				graphData,
				isGraphReport: true,
			});
		}
	};

	const handleAddCustomCard = useCallback(async (key) => {
		let cards = [...hospitalCards];
		if (key === "selectAll") {
			cards = _.map(HOSPITAL_CUSTOM_CARD_DATA, "value");
		} else if (key === "clearAll") {
			cards = []
		} else {
			if (!cards.includes(key)) {
				cards.push(key);
			} else {
				cards.splice(cards.indexOf(key), 1);
			}
		}
		dispatch(setHospitalCards(cards));

		// Update layout to include new cards in standalone
		const currentLayout = getCurrentLayout();
		if (key !== "clearAll") {
			const newCards = cards.map((cId) => {
				const gridId = resolveLayoutCardIdForSelectedCard(cId, dynamicCards, patientList?.customTabs);
				const inCategory = currentLayout.categories.some((cat) =>
					cat.cards.some((c) => c.id === gridId || c.id === cId)
				);
				const inStandalone = currentLayout.standalone.some(
					(c) => c.id === gridId || c.id === cId
				);

				if (!inCategory && !inStandalone) {
					return { id: gridId, width: getCardWidth(cId), position: cards.indexOf(cId) };
				}
				return null;
			}).filter(Boolean);

			if (newCards.length > 0) {
				setTempLayout(
					ensureHospitalRootOrder({
						...currentLayout,
						standalone: [...currentLayout.standalone, ...newCards],
					})
				);
				setHasLayoutChanges(true);
			}
		} else {
			setTempLayout(
				ensureHospitalRootOrder({ ...currentLayout, standalone: [], categories: [] })
			);
			setHasLayoutChanges(true);
		}
	}, [
		hospitalCards,
		dispatch,
		HOSPITAL_CUSTOM_CARD_DATA,
		getCurrentLayout,
		dynamicCards,
		patientList?.customTabs,
	]);

	// AI Report Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiReportActionsService.initialize(
			handleOnClickReport,
			downloadExcel,
			() => ({ hospital: { filterListData, cardFilter, transferType, dbData } })
		);
	}, [handleOnClickReport, downloadExcel, filterListData, cardFilter, transferType, dbData]);
	*/

	// AI Transfer Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiTransferActionsService.initialize(
			handleOnclickCard,
			handleClickTotal,
			() => ({ hospital: { dbData, transferType } })
		);
	}, [handleOnclickCard, handleClickTotal, dbData, transferType]);
	*/

	// AI Dialog Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiDialogActionsService.initialize(
			handleChartDialog,
			() => ({
				hospital: {
					dbData,
					transferType,
					filterListData,
					cardFilter,
					activeFacilities,
					dynamicCards,
					patientList
				}
			})
		);
	}, [handleChartDialog, dbData, transferType, filterListData, cardFilter, activeFacilities, dynamicCards, patientList]);
	*/

	// Auto-select all custom cards once everything is rendered
	useEffect(() => {
		// Check if data is loaded, not loading, and we have the necessary data
		if (dbData && !loading && !hospitalLoading && activeFacilities && activeFacilities.length > 0) {
			// Always ensure all available cards are selected for all users
			const allAvailableValues = HOSPITAL_CUSTOM_CARD_DATA.map(card => card.value);
			const missingCards = allAvailableValues.filter(val => !hospitalCards.includes(val));

			if (missingCards.length > 0) {
				const updatedCards = [...hospitalCards, ...missingCards];
				dispatch(setHospitalCards(updatedCards));
			}
		}
	}, [dbData, loading, hospitalLoading, activeFacilities, hospitalCards, dispatch, HOSPITAL_CUSTOM_CARD_DATA]);


	const handleSaveLayout = useCallback(async (options = {}) => {
		const { skipExitAfterSave = false, saveForBothLayouts = false } = options;
		try {
			const layoutToSave = applyCollapsedStateToLayout(
				ensureHospitalRootOrder(
					patchHospitalLayoutBase(tempLayout?.version ? tempLayout : migrateLayout(hospitalLayout))
				),
				collapsedCategoryIds
			);

			const emptyCategory = (layoutToSave.categories || []).find(
				(cat) => !cat.cards || cat.cards.length === 0
			);
			if (emptyCategory) {
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						label: "A category must contain at least one item.",
						type: "error",
						id: "emptyCategoryHospital",
					},
				});
				return false;
			}

			// Save to database (special case: save both default + personal).
			await saveLayoutToDatabase(
				{
					page: PAGE_TYPE.HOSPITAL,
					layout: layoutToSave,
					cards: hospitalCards,
					timestamp: new Date().toISOString()
				},
				currentLayoutType
			);
			if (saveForBothLayouts) {
				const mirrorLayoutType = currentLayoutType === 'default' ? 'personal' : 'default';
				await saveLayoutToDatabase(
					{
						page: PAGE_TYPE.HOSPITAL,
						layout: layoutToSave,
						cards: hospitalCards,
						timestamp: new Date().toISOString()
					},
					mirrorLayoutType
				);
			}

			dispatch(setHospitalLayout(layoutToSave));
			setHasLayoutChanges(false);

			const layoutTypeText = saveForBothLayouts
				? 'default and personal'
				: currentLayoutType === 'default'
					? 'default'
					: 'personal';
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					label: `Your ${layoutTypeText} layout has been saved successfully.`,
					type: "success",
					id: "savedCustomLayoutHospital",
				},
			});
			if (!skipExitAfterSave) {
				handleToggleLayoutModeRef.current?.(true);
			}
			return true;
		} catch (error) {
			console.error('Error saving layout:', error);
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					label: 'Failed to save layout. Please try again.',
					type: "error",
					id: "saveFailedHospital",
				},
			});
			return false;
		}
	}, [tempLayout, migrateLayout, hospitalLayout, hospitalCards, currentLayoutType, dispatch, patchHospitalLayoutBase, collapsedCategoryIds]);

	const handleToggleLayoutMode = useCallback(async (isSkipSave = false) => {
		if (isLayoutMode) {
			// Exiting layout mode - auto-save changes
			if (hasLayoutChanges && !isSkipSave) {
				const saved = await handleSaveLayout({ skipExitAfterSave: true });
				if (!saved) {
					return;
				}
			}

			// For super users: if currently viewing default layout, switch back to personal layout
			if (isSuperUser && currentLayoutType === 'default') {
				try {
					const rawLayout = await fetchLayoutByType('personal');
					if (rawLayout != null && typeof rawLayout === 'object') {
						const normalizedLayout = ensureHospitalRootOrder(
							patchHospitalLayoutBase(migrateLayout(rawLayout))
						);
						dispatch(setHospitalLayout(normalizedLayout));
						setCollapsedCategoryIds(getCollapsedIdsFromLayout(normalizedLayout, false));
						setCurrentLayoutType('personal');
					} else {
						const defaultLayout = generateDefaultLayout();
						dispatch(setHospitalLayout(defaultLayout));
						setCollapsedCategoryIds({});
						setCurrentLayoutType('personal');
					}
				} catch (error) {
					console.error('Error switching back to personal layout:', error);
					const defaultLayout = generateDefaultLayout();
					dispatch(setHospitalLayout(defaultLayout));
					setCollapsedCategoryIds({});
					setCurrentLayoutType('personal');
				}
			}

			dispatch(setIsLayoutMode(false));
			setHasLayoutChanges(false);
			setTempLayout({});
		} else {
			// Entering layout mode
			dispatch(setIsLayoutMode(true));
			const currentLayout = ensureHospitalRootOrder(
				patchHospitalLayoutBase(migrateLayout(hospitalLayout))
			);
			setTempLayout(currentLayout);
		}
	}, [isLayoutMode, hasLayoutChanges, hospitalLayout, generateDefaultLayout, currentLayoutType, dispatch, isSuperUser, migrateLayout, handleSaveLayout, patchHospitalLayoutBase, fetchLayoutByType]);

	handleToggleLayoutModeRef.current = handleToggleLayoutMode;


	const handleLayoutChangeInCategory = useCallback((categoryId, newCards) => {
		const currentLayout = getCurrentLayout();
		const updatedCategories = currentLayout.categories.map(cat => {
			if (cat.id === categoryId) {
				return { ...cat, cards: newCards };
			}
			return cat;
		});
		setTempLayout(ensureHospitalRootOrder({ ...currentLayout, categories: updatedCategories }));
		setHasLayoutChanges(true);
	}, [getCurrentLayout]);

	const scrollToCategory = useCallback((categoryId) => {
		let attempts = 0;
		const maxAttempts = 20;
		const tryScroll = () => {
			const el = document.querySelector(`[data-category-id="${categoryId}"]`);
			if (el) {
				el.scrollIntoView({ behavior: 'smooth', block: 'center' });
				return;
			}
			if (attempts < maxAttempts) {
				attempts += 1;
				requestAnimationFrame(tryScroll);
			}
		};
		requestAnimationFrame(tryScroll);
	}, []);

	const handleCreateCategory = useCallback(() => {
		const currentLayout = getCurrentLayout();
		const newCategory = {
			id: `category_${Date.now()}`,
			title: 'New Category',
			cards: []
		};
		setTempLayout(
			ensureHospitalRootOrder({
				...currentLayout,
				categories: [...currentLayout.categories, newCategory],
			})
		);
		setHasLayoutChanges(true);
		scrollToCategory(newCategory.id);
	}, [getCurrentLayout, scrollToCategory]);

	const handleAddCategoryFromMenu = useAddCategoryFromMenu({
		pageLabel: 'Hospital',
		fetchLayoutByType,
		getCurrentLayout,
		patchLayoutBase: patchHospitalLayoutBase,
		migrateLayout,
		dispatch,
		setPageLayout: setHospitalLayout,
		setLayoutTypeLoading,
		setCurrentLayoutType,
		setTempLayout,
		setHasLayoutChanges,
		scrollToCategory,
	});

	const handleUpdateCategoryTitle = useCallback((id, newTitle) => {
		const currentLayout = getCurrentLayout();
		const updatedCategories = currentLayout.categories.map(cat => {
			if (cat.id === id) {
				return { ...cat, title: newTitle };
			}
			return cat;
		});
		setTempLayout(ensureHospitalRootOrder({ ...currentLayout, categories: updatedCategories }));
		setHasLayoutChanges(true);
	}, [getCurrentLayout]);

	const handleDeleteCategory = useCallback((id) => {
		const currentLayout = getCurrentLayout();
		const categoryToDelete = currentLayout.categories.find((cat) => cat.id === id);
		const cardsToMove = categoryToDelete?.cards || [];

		const updatedCategories = currentLayout.categories.filter((cat) => cat.id !== id);
		const standaloneIds = new Set((currentLayout.standalone || []).map((c) => c.id));
		const cardsToAppend = cardsToMove.filter((c) => !standaloneIds.has(c.id));
		const updatedStandalone = [...(currentLayout.standalone || []), ...cardsToAppend];

		setTempLayout(
			ensureHospitalRootOrder({
				...currentLayout,
				standalone: updatedStandalone,
				categories: updatedCategories,
			})
		);
		setHasLayoutChanges(true);
	}, [getCurrentLayout]);

	const handleRootGapDrop = useCallback(
		(cardId, rootOrderIndex, _e, dragType) => {
			if (!cardId || typeof rootOrderIndex !== "number") return;
			const currentLayout = getCurrentLayout();

			const isCategoryDrag =
				dragType === "category"
				|| currentLayout.categories.some((c) => c.id === cardId);
			if (isCategoryDrag) {
				const rootOrder = currentLayout.rootOrder || [];
				const fromIdx = rootOrder.findIndex((e) => e.id === cardId);
				if (fromIdx === -1) return;

				const cardDataNow = cardDataRef.current || [];
				const visibleRootOrder = rootOrder.filter((entry) => {
					if (entry.type === "category") return true;
					const def = cardDataNow.find((c) => c.id === entry.id);
					return Boolean(def?.component);
				});
				let translatedRootOrderIndex;
				if (rootOrderIndex >= visibleRootOrder.length) {
					translatedRootOrderIndex = rootOrder.length;
				} else {
					const targetId = visibleRootOrder[rootOrderIndex]?.id;
					const found = targetId ? rootOrder.findIndex((e) => e.id === targetId) : -1;
					translatedRootOrderIndex = found === -1 ? rootOrder.length : found;
				}

				const nextRootOrder = [...rootOrder];
				const [moved] = nextRootOrder.splice(fromIdx, 1);
				const adjustedTo = translatedRootOrderIndex > fromIdx
					? translatedRootOrderIndex - 1
					: translatedRootOrderIndex;
				nextRootOrder.splice(adjustedTo, 0, moved);
				const renumbered = nextRootOrder.map((e, i) => ({ ...e, position: i }));
				setTempLayout(
					ensureHospitalRootOrder({ ...currentLayout, rootOrder: renumbered })
				);
				setHasLayoutChanges(true);
				draggedCardIdRef.current = null;
				dragSourceRef.current = null;
				setTimeout(() => {
					setDraggedCardId(null);
					setHoveredCategoryId(null);
					setHoveredStandalone(false);
					setDragSource(null);
				}, 50);
				return;
			}

			// If the card is leaving its category and that was the last card, the
			// category becomes empty — drop it, matching the behavior of
			// `handleMoveCardToCategory`.
			const sourceCat = currentLayout.categories.find((cat) =>
				cat.cards.some((c) => c.id === cardId)
			);
			const removeEmptySourceCategoryId =
				sourceCat && sourceCat.cards.length === 1 ? sourceCat.id : null;

			// Translate the orderedCards-relative index that the RootGap component
			// passed (`index={idx}` for mid-list gaps, `index={orderedCards.length}`
			// for the trailing gap) into an index in the FULL `layout.rootOrder`.
			// They diverge whenever rootOrder contains entries that get filtered
			// out of the rendered grid (`hospitalMainGridPayload`'s cardsForGrid
			// drops standalone entries whose `cardData` has no `component`). With
			// no translation, dropping at the trailing gap inserts the card in the
			// middle of rootOrder rather than at the end — so the card visually
			// drifts a slot or two and looks like it "didn't move."
			//
			// `cardData` is declared further down in the file, so we read it via
			// a ref written each render (see `cardDataRef` below). Putting
			// `cardData` directly in the useCallback deps would access it during
			// the very first render of this hook — before its `const` runs —
			// triggering "Cannot access 'cardData' before initialization."
			const rootOrder = currentLayout.rootOrder || [];
			const cardDataNow = cardDataRef.current || [];
			const visibleRootOrder = rootOrder.filter((entry) => {
				if (entry.type === "category") return true;
				const def = cardDataNow.find((c) => c.id === entry.id);
				return Boolean(def?.component);
			});
			let translatedRootOrderIndex;
			if (rootOrderIndex >= visibleRootOrder.length) {
				translatedRootOrderIndex = rootOrder.length;
			} else {
				const targetId = visibleRootOrder[rootOrderIndex]?.id;
				const found = targetId ? rootOrder.findIndex((e) => e.id === targetId) : -1;
				translatedRootOrderIndex = found === -1 ? rootOrder.length : found;
			}

			let next = computeLayoutAfterRootGapInsert(currentLayout, cardId, translatedRootOrderIndex);
			if (!next) return;

			if (removeEmptySourceCategoryId) {
				next = {
					...next,
					categories: next.categories.filter((c) => c.id !== removeEmptySourceCategoryId),
					rootOrder: (next.rootOrder || []).filter(
						(e) => e.id !== removeEmptySourceCategoryId
					),
				};
			}

			setTempLayout(ensureHospitalRootOrder(next));
			setHasLayoutChanges(true);

			// CRITICAL: clear the drag refs synchronously. After this drop event,
			// the source cell's `dragend` still fires and walks the category-source
			// `onDragStop` chain — that chain sees the release point over root area
			// (a gap has no `[data-category-id]` ancestor), classifies it as a
			// standalone drop, and calls `handleCardDrop("standalone", ...)`. That
			// would overwrite the gap-targeted insert with a plain append. Nulling
			// `draggedCardIdRef.current` here makes `handleCardDrop` early-return at
			// its `if (!activeId) return;` guard, so the gap insert wins.
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			suppressCategoryInnerPersistRef.current = true;
			setTimeout(() => {
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
			}, 50);
			queueMicrotask(() => {
				suppressCategoryInnerPersistRef.current = false;
			});
		},
		[getCurrentLayout]
	);

	const handleCardDropAtCategoryEdge = useCallback(
		(cardId, position, targetCategoryId) => {
			if (!cardId || !targetCategoryId) return;
			const layoutNow = getCurrentLayout();
			const targetCat = layoutNow.categories.find((c) => c.id === targetCategoryId);
			if (!targetCat) return;
			// Filter out the moved card from the destination's existing cards so
			// we resolve the right "first card" when reordering within the same
			// category — otherwise dropping the first card on the start gap would
			// `insertBeforeId` itself and yield a no-op.
			const others = (targetCat.cards || []).filter((c) => c.id !== cardId);
			const insertBeforeId =
				position === 'start' && others.length > 0 ? others[0].id : null;
			handleMoveCardToCategory(cardId, targetCategoryId, {
				categoryInsertBeforeId: insertBeforeId,
			});
			// Same reasoning as `handleRootGapDrop`: clear refs synchronously so
			// the source's `onDragStop` chain (which fires after this drop event)
			// early-returns at `if (!activeId) return;` instead of re-applying a
			// generic standalone/category drop on top of our edge insert.
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			suppressCategoryInnerPersistRef.current = true;
			setTimeout(() => {
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
			}, 50);
			queueMicrotask(() => {
				suppressCategoryInnerPersistRef.current = false;
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[getCurrentLayout]
	);

	const handleMoveCardToCategory = useCallback((cardId, toCategoryId, moveOptions) => {
		const currentLayout = getCurrentLayout();
		const normalizedTarget =
			toCategoryId === "standalone" || !toCategoryId ? "standalone" : toCategoryId;

		const sourceCat = currentLayout.categories.find((cat) =>
			cat.cards.some((c) => c.id === cardId)
		);
		const leavingCategory =
			sourceCat &&
			(normalizedTarget === "standalone" || normalizedTarget !== sourceCat.id);
		const removeEmptySourceCategoryId =
			sourceCat && sourceCat.cards.length === 1 && leavingCategory ? sourceCat.id : null;

		let next = computeLayoutAfterCardMove(
			currentLayout,
			cardId,
			normalizedTarget,
			moveOptions || {}
		);
		if (!next) return "noop";

		if (removeEmptySourceCategoryId) {
			next = {
				...next,
				categories: next.categories.filter((c) => c.id !== removeEmptySourceCategoryId),
			};
		}

		setTempLayout(ensureHospitalRootOrder(next));
		setHasLayoutChanges(true);
		return removeEmptySourceCategoryId ? "done_removed_empty_category" : "done";
	}, [getCurrentLayout]);

	const handleRootGridChange = useCallback(
		(orderedItems) => {
			const current = getCurrentLayout();
			const catIds = new Set(current.categories.map((c) => c.id));
			const rootOrder = orderedItems.map((it, i) => ({
				id: it.id,
				type: catIds.has(it.id) ? "category" : "card",
				width: catIds.has(it.id) ? 12 : it.width || 4,
				position: i,
			}));
			setTempLayout(
				ensureHospitalRootOrder({
					...current,
					rootOrder,
				})
			);
			setHasLayoutChanges(true);
		},
		[getCurrentLayout]
	);

	const handleCardDrop = useCallback(
		(targetId, targetTitle = "General Cards", dropEvent) => {
			// Refs are updated synchronously on drag start; RGL onDragStop can run before React commits useState.
			const activeId = draggedCardIdRef.current;
			if (!activeId) return;

			const activeSource = dragSourceRef.current;

			if (activeSource === targetId) {
				draggedCardIdRef.current = null;
				dragSourceRef.current = null;
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
				return;
			}

			const isStandaloneTarget = targetId === "standalone" || !targetId;
			// Resolve a pointer for both standalone AND category drops. Category drops
			// (e.g. CategoryBox onCardDrop) don't always pass a drop event, so fall back
			// to the last-known pointer just like standalone drops do.
			const pt =
				getPointerClientCoords(dropEvent) ||
				categoryDragPointerRef.current ||
				(Date.now() - lastPointerRef.current.timestamp < 500
					? lastPointerRef.current
					: null);
			const standaloneInsertBeforeId = isStandaloneTarget
				? getStandaloneInsertBeforeIdFromPoint(pt, activeId)
				: null;
			// When dropping into a category onto a specific card, insert at that card's slot
			// instead of appending at the end. Falls back to append when the pointer is over
			// the category's empty space or the drop event has no usable coordinates.
			const categoryInsertTarget =
				!isStandaloneTarget && pt
					? getCategoryInsertBeforeTargetFromPoint(pt, activeId, {
						categoryId: targetId,
					})
					: null;
			const categoryInsertBeforeId =
				categoryInsertTarget && categoryInsertTarget.categoryId === targetId
					? categoryInsertTarget.insertBeforeId
					: null;

			const result = handleMoveCardToCategory(activeId, targetId, {
				...(isStandaloneTarget
					? { standaloneInsertBeforeId }
					: { categoryInsertBeforeId }),
			});
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			setDraggedCardId(null);
			setHoveredCategoryId(null);
			setHoveredStandalone(false);
			setDragSource(null);

			if (result === "done" || result === "done_removed_empty_category") {


				if (targetId && targetId !== "standalone") {
					if (dropFlashTimeoutRef.current) {
						clearTimeout(dropFlashTimeoutRef.current);
					}
					setDropFlashCategoryId(targetId);
					dropFlashTimeoutRef.current = setTimeout(() => {
						setDropFlashCategoryId(null);
						dropFlashTimeoutRef.current = null;
					}, 750);
				}
			}
		},
		[handleMoveCardToCategory]
	);

	const handleLayoutTypeChange = useCallback(async (layoutType) => {
		try {
			setLayoutTypeLoading(true);
			setCurrentLayoutType(layoutType);
			const rawLayout = await fetchLayoutByType(layoutType);
			if (rawLayout != null && typeof rawLayout === 'object') {
				const nestedLayout = ensureHospitalRootOrder(
					patchHospitalLayoutBase(migrateLayout(rawLayout))
				);
				dispatch(setHospitalLayout(nestedLayout));
				setCollapsedCategoryIds(getCollapsedIdsFromLayout(nestedLayout, false));
				setTempLayout(nestedLayout);
			} else {
				// If no layout exists for this type, use default layout
				const defaultLayout = migrateLayout(null);
				dispatch(setHospitalLayout(defaultLayout));
				setCollapsedCategoryIds({});
				setTempLayout(defaultLayout);
			}

			setHasLayoutChanges(false);

			// Enter layout mode automatically when switching types
			dispatch(setIsLayoutMode(true));

		} catch (error) {
			console.error('Error switching layout type:', error);
			// Fallback to default layout
			const defaultLayout = migrateLayout(null);
			dispatch(setHospitalLayout(defaultLayout));
			setTempLayout(defaultLayout);
			dispatch(setIsLayoutMode(true));
		} finally {
			// Add a small delay to ensure cards are rendered before hiding loader
			setTimeout(() => {
				setLayoutTypeLoading(false);
			}, 500);
		}
	}, [dispatch, migrateLayout, patchHospitalLayoutBase, fetchLayoutByType]);

	const handleResetLayout = useCallback(async () => {
		try {
			const rawLayout = await fetchDefaultLayout();
			if (rawLayout != null && typeof rawLayout === 'object') {
				setTempLayout(migrateLayout(rawLayout));
				setHasLayoutChanges(true);
			} else {
				setTempLayout(migrateLayout(null));
				setHasLayoutChanges(true);
			}
		} catch (error) {
			console.error('Error resetting layout:', error);
			setTempLayout(migrateLayout(null));
			setHasLayoutChanges(true);
		}
	}, [migrateLayout, fetchDefaultLayout]);

	const [scrollPosition, setScrollPosition] = useState({ scrollTop: 0 });
	const scrollDemoRef = useRef(null);
	const handleScroll = () => {
		if (scrollDemoRef.current) {
			const { scrollTop } = scrollDemoRef.current;
			setScrollPosition({ scrollTop });
		}
	};

	useEffect(() => {
		if (scrollDemoRef.current) {
			scrollDemoRef.current.style.overflowY = 'auto';
			scrollDemoRef.current.style.overflowX = isLayoutMode ? 'hidden' : '';
		}
		document.body.style.overflow = '';
		document.body.style.backgroundColor = '';
		return () => {
			if (scrollDemoRef.current) {
				// eslint-disable-next-line react-hooks/exhaustive-deps
				scrollDemoRef.current.style.overflowY = '';
				// eslint-disable-next-line react-hooks/exhaustive-deps
				scrollDemoRef.current.style.overflowX = '';
			}
			document.body.style.overflow = '';
			document.body.style.backgroundColor = '';
		};
	}, [isLayoutMode]);

	const layoutZoomWrapperRef = useRef(null);
	const layoutZoomScale = isMobile
		? HOSPITAL_LAYOUT_MODE_ZOOM_MOBILE
		: HOSPITAL_LAYOUT_MODE_ZOOM_DESKTOP;
	useLayoutEffect(() => {
		const node = layoutZoomWrapperRef.current;
		if (!node) return undefined;
		if (!isLayoutMode) {
			node.style.marginBottom = '';
			return undefined;
		}
		let raf = null;
		const update = () => {
			const natural = node.offsetHeight;
			if (!(natural > 0)) return;
			const negative = natural * (1 - layoutZoomScale);
			node.style.marginBottom = `-${negative}px`;
		};
		update();
		let ro;
		if (typeof ResizeObserver !== 'undefined') {
			ro = new ResizeObserver(() => {
				if (raf) cancelAnimationFrame(raf);
				raf = requestAnimationFrame(update);
			});
			ro.observe(node);
		}
		return () => {
			if (raf) cancelAnimationFrame(raf);
			if (ro) ro.disconnect();
			node.style.marginBottom = '';
		};
	}, [isLayoutMode, layoutZoomScale]);

	// Prepare card data for drag-and-drop layout
	const cardData = useMemo(() => {
		const cards = [];

		// Only include cards that are actually selected/visible
		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS),
				component: 'hospitalizations'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DCER_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.DCER_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DCER_DATA),
				component: 'dcer'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.INSURANCE_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.INSURANCE_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.INSURANCE_DATA),
				component: 'insurance'
			});
		}

		if (isAllowReturnCard && _.includes(hospitalCards, HOSPITAL_CARDS_TYPE.RETURNS_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.RETURNS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.RETURNS_DATA),
				component: 'returns'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA),
				component: 'ninetyDays'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.FLOORS_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.FLOORS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.FLOORS_DATA),
				component: 'floors'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DOCTOR_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.DOCTOR_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DOCTOR_DATA),
				component: 'doctor'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DAYS_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.DAYS_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DAYS_DATA),
				component: 'days'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.DX_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.DX_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.DX_DATA),
				component: 'dx'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.SHIFT_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.SHIFT_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.SHIFT_DATA),
				component: 'shift'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.NURSE_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.NURSE_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.NURSE_DATA),
				component: 'nurse'
			});
		}

		if (_.includes(hospitalCards, HOSPITAL_CARDS_TYPE.HOSPITAL_DATA)) {
			cards.push({
				id: HOSPITAL_CARDS_TYPE.HOSPITAL_DATA,
				width: getCardWidth(HOSPITAL_CARDS_TYPE.HOSPITAL_DATA),
				component: 'hospital'
			});
		}

		// Add dynamic cards to the drag-and-drop system
		if (dynamicCards?.length > 0) {
			dynamicCards.forEach((ele) => {
				if (_.includes(hospitalCards, ele.accessor)) {
					const row = HOSPITAL_CUSTOM_CARD_DATA.find((r) => r.value === ele?.accessor && !r.isCustomTab);
					cards.push({
						id: getDynamicCardLayoutId(ele.accessor),
						width: 4, // Default width for dynamic cards (lg=4)
						component: 'dynamic',
						data: {
							...ele,
							isCustomTab: false,
							...(row && {
								_id: row._id || ele?._id,
								shareCount: row.shareCount ?? ele.shareCount,
								isUniversalAccess: row.isUniversalAccess ?? ele.isUniversalAccess,
								isUniversal: row.isUniversal ?? ele.isUniversal,
								isShared: row.isShared ?? ele.isShared,
								isCustomShare: row.isCustomShare ?? ele.isCustomShare,
								shareInfo: row.shareInfo ?? ele.shareInfo,
								sharedBy: row.sharedBy ?? ele.sharedBy,
								sharedByName: row.sharedByName ?? ele.sharedByName,
								shareId: row.shareId ?? ele.shareId,
							}),
						},
					});
				}
			});
		}

		// Add custom tab cards to the drag-and-drop system
		if (patientList?.customTabs?.length > 0) {
			patientList.customTabs.forEach((ele) => {
				if (_.includes(hospitalCards, ele.accessor)) {
					cards.push({
						id: getCustomTabCardLayoutId(ele.accessor),
						width: 4, // Default width for custom tab cards (lg=4)
						component: 'dynamic',
						data: { ...ele, isCustomTab: true }
					});
				}
			});
		}
		return cards;
	}, [hospitalCards, isAllowReturnCard, dynamicCards, patientList?.customTabs, HOSPITAL_CUSTOM_CARD_DATA]);

	// Sync the ref so earlier-defined callbacks (handleRootGapDrop) can read
	// the current cardData without violating the temporal dead zone.
	cardDataRef.current = cardData;

	const hospitalMainGridPayload = useMemo(() => {
		const lo = getCurrentLayout();
		const rootOrder = lo.rootOrder || [];
		const layoutForDrag = [];
		const cardsForGrid = [];
		rootOrder.forEach((entry) => {
			if (entry.type === "category") {
				const cat = lo.categories.find((c) => c.id === entry.id);
				if (!cat) return;
				const visibleCategoryCards = (cat.cards || [])
					.map((cardItem) => cardData.find((c) => c.id === cardItem.id))
					.filter(Boolean);
				// Main view: hide empty category boxes when all cards in that category are hidden.
				if (!isLayoutMode && visibleCategoryCards.length === 0) return;
				const categoryForSizing = !isLayoutMode
					? { ...cat, cards: visibleCategoryCards }
					: cat;
				const isCollapsed = !isLayoutMode && Boolean(collapsedCategoryIds[entry.id]);
				const gridH = isCollapsed
					? 3
					: estimateCategoryGridRowUnits(categoryForSizing, cardData, {
						compactTwoCol: categoryInnerTwoCol,
					});
				const pos = layoutForDrag.length;
				layoutForDrag.push({
					id: entry.id,
					type: entry.type,
					width: entry.width,
					position: pos,
					title: entry.title,
				});
				cardsForGrid.push({
					id: entry.id,
					type: "category",
					width: 12,
					gridH,
				});
				return;
			}
			const def = cardData.find((c) => c.id === entry.id);
			if (!def?.component) return;
			const s = lo.standalone.find((c) => c.id === entry.id);
			const pos = layoutForDrag.length;
			layoutForDrag.push({
				id: entry.id,
				type: entry.type,
				width: entry.width,
				position: pos,
				title: entry.title,
			});
			cardsForGrid.push({
				...def,
				...s,
				id: entry.id,
				type: "card",
				width: s?.width ?? def?.width ?? 4,
				gridH: 24,
			});
		});
		return { layoutForDrag, cardsForGrid };
	}, [getCurrentLayout, cardData, isLayoutMode, collapsedCategoryIds, categoryInnerTwoCol]);

	const persistCollapsedCategories = useCollapsedCategoriesPersistence({
		page: PAGE_TYPE.HOSPITAL,
		layoutType: currentLayoutType,
		layout: hospitalLayout,
		cards: hospitalCards,
	});

	const handleToggleCategoryCollapse = useCallback(
		(categoryId) => {
			setCollapsedCategoryIds((prev) => {
				const next = {
					...prev,
					[categoryId]: !prev?.[categoryId],
				};
				persistCollapsedCategories(next);

				// Keep Redux in sync AFTER the animation settles so we don't
				// interrupt the 1400ms CategoryBox expand/collapse transition.
				setTimeout(() => {
					dispatch((dispatchArg, getState) => {
						const { hospitalLayout: currentLayout } = getState().customCard;
						if (!currentLayout) return;
						const synced = applyCollapsedStateToLayout(currentLayout, next);
						dispatchArg(setHospitalLayout(synced));
					});
				}, 1500);

				return next;
			});
		},
		[persistCollapsedCategories, dispatch]
	);

	const prepareScrollToCard = useCallback(
		async (targetId) => {
			if (isLayoutMode) return;
			const lo = getCurrentLayout();
			const categoryId = findCategoryIdContainingCard(lo, targetId);
			if (!categoryId) return;
			// Detect collapsed state BEFORE mutating so we can decide whether
			// we actually need to play the maximize animation.
			const wasCollapsed = Boolean(collapsedCategoryIds[categoryId]);
			if (!wasCollapsed) return;
			// Bring the minimized category into view FIRST so the user can
			// actually watch it expand. Without this, the category is often
			// below the fold — the 1400ms maximize animation plays off-screen
			// and by the time scrollIntoView (below, on the card) fires, the
			// box is already fully open. Finding the node by `data-category-id`
			// (set on the CategoryBox Paper) is stable across re-renders.
			const categoryEl = document.querySelector(
				`[data-category-id="${categoryId}"]`
			);
			if (categoryEl) {
				try {
					categoryEl.scrollIntoView({ behavior: 'auto', block: 'center' });
				} catch { /* non-fatal */ }
			}
			// Give the scroll a frame to settle before triggering the state
			// change that drives the animation, so the user's eyes are already
			// on the category when it starts expanding.
			await new Promise((resolve) => {
				requestAnimationFrame(() => requestAnimationFrame(resolve));
			});
			setCollapsedCategoryIds((prev) => {
				if (!prev[categoryId]) return prev;
				return { ...prev, [categoryId]: false };
			});
			// Wait for the CategoryBox maximize animation to visibly complete
			// BEFORE the caller scrolls to the target card and fires the
			// highlight flash. This duration must be >= the enter timing
			// configured in CategoryBox's Collapse (`timeout.enter`) and the
			// matching outer `.react-grid-item` CSS transition in
			// DragDropLayout (`:has([data-category-id][data-collapsed="false"])`).
			// Both are currently 1400ms — 1500ms gives a tiny buffer so the
			// last frame of the animation has painted before we scroll.
			await new Promise((resolve) => {
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						setTimeout(resolve, 1500);
					});
				});
			});
		},
		[getCurrentLayout, isLayoutMode, collapsedCategoryIds]
	);

	// AI Chat handlers
	const handleAiChatToggle = useCallback(() => {
		setAiChatOpen(!aiChatOpen);
		if (!aiChatOpen) {
			setAiChatUnreadCount(0); // Clear unread count when opening
		}
	}, [aiChatOpen]);

	const handleAiChatClose = useCallback(() => {
		setAiChatOpen(false);
		setAiChatMinimized(false);
	}, []);

	const handleAiChatMinimizeStateChange = useCallback((isMinimized) => {
		setAiChatMinimized(isMinimized);
	}, []);

	// handleVectorStoreIdUpdate — disabled (new agent API never invokes this callback)
	/*
	const handleVectorStoreIdUpdate = useCallback((vectorStoreId) => {
		setAiVectorStoreId(vectorStoreId);

		// Vector store caching + cleanup registration — disabled (new agent API does not use vector stores)
		// Cache the vector store ID for the current context
		const cacheKey = getVectorStoreCacheKey();
		if (cacheKey && vectorStoreId) {
			localStorage.setItem(cacheKey, vectorStoreId);

			// Register for cleanup on logout
			registerVectorStoreId(vectorStoreId, 'hospital');
		}
	}, [getVectorStoreCacheKey]);
	*/

	// State for default chart data for AI analysis
	const [defaultChartData, setDefaultChartData] = useState({
		chartData: null,
		aggregationType: 'unknown',
		currentFilter: null
	});

	// Generate default chart data for AI analysis (weekly view by default)
	useEffect(() => {
		const generateChartData = async () => {
			if (!patientList?.list || patientList.list.length === 0 || !filter) {
				setDefaultChartData({
					chartData: null,
					aggregationType: 'unknown',
					currentFilter: null
				});
				return;
			}

			try {
				// Add facilityName to patient data for chart processing
				const patientDataWithFacility = patientList.list.map((patient) => ({
					...patient,
					facilityName: patient?.facility?.name || 'Unknown'
				}));

				// Generate chart data using the same logic as the dialog
				const chartDataArr = await chartsData(patientDataWithFacility, filter);

				// Default to weekly aggregation for AI analysis
				const censusByPeriodData = patientList.censusByPeriod || [];
				const censusAverageData = String(getPercentageByTotal({
					censusAverage: patientList.censusAverage,
					total: patientList.list.length
				}));

				// Group by week for default chart view
				const latestChartData = await chartGroupBy(
					chartDataArr,
					'week', // Default to weekly view
					censusAverageData,
					censusByPeriodData,
					filter
				);

				setDefaultChartData({
					chartData: latestChartData || [],
					aggregationType: 'weekly',
					currentFilter: 'week'
				});
			} catch (error) {
				setDefaultChartData({
					chartData: null,
					aggregationType: 'unknown',
					currentFilter: null
				});
			}
		};

		generateChartData();
	}, [patientList, filter]);

	// Prepare AI chat context data using the new modular hooks
	const aiChatContext = useAIChatContext({
		// Page identification
		pageType: PAGE_TYPE.HOSPITAL, // CRITICAL: Identifies this as Hospital page for correct API endpoint and vector store

		// Core data dependencies
		dbData,
		filterListData,
		patientList,
		activeFacilities,
		facilities,
		dynamicCards,

		// Filter and state dependencies
		filter,
		transferType,
		cardFilter,
		percentageBy,
		lockedTotalBy,
		specialComparisonSet,
		filterTotal,
		percentageAgainst,
		projectionDays,
		lastADTDate,

		// UI state dependencies
		hospitalCards,
		rangesSet,
		isLayoutMode,

		// Function dependencies
		getPriorityNumber,
		lockedTotal,
		lockedByFacility,
		isCensusTotalLocked,
		facilityPercentage,

		// Metadata dependencies
		HOSPITAL_CUSTOM_CARD_DATA,
		tooltipsInfo,

		// Service dependencies — disabled (services not initialized; optional chaining inside the hook handles undefined)
		/*
		aiCensusActionsService,
		aiReportActionsService,
		aiTransferActionsService,
		aiDialogActionsService,
		aiDateSuggestionsService,
		*/

		// Chart data dependencies (NEW - for chart trend analysis)
		chartData: defaultChartData.chartData,
		chartAggregationType: defaultChartData.aggregationType,
		currentChartFilter: defaultChartData.currentFilter
	});

	// Pre-load AI conversation with comprehensive context for faster responses
	const preloadAIConversation = useCallback(async () => {
		try {
			// Only preload if we haven't already and we have sufficient data
			if (aiContextPreloaded || !patientList?.list?.length || !filterListData || !aiChatContext) {
				return;
			}
			// Import AI chat service dynamically to avoid circular dependencies
			const { default: aiChatService } = await import('../services/ai-chat.service');

			// Use the same context that's already being used for regular AI chat
			// This ensures consistency between preload and regular contexts

			// Send preload message to establish conversation context
			const preloadMessage = `Initialize conversation context for Hospital dashboard analysis. 
			Data loaded: ${aiChatContext.pageData.metrics.totalTransfers} total transfers, 
			${aiChatContext.pageData.filters.facilities.count} facilities, 
			${aiChatContext.pageData.currentState.availableDataCategories.length} card types available.
			Ready for user questions about hospital transfer data and analytics.`;

			// Create conversation with the same context used for regular chat
			const response = await aiChatService.preloadConversation(preloadMessage, aiChatContext);

			if (response?.conversationId) {
				setAiConversationId(response.conversationId);
				setAiContextPreloaded(true);
			}
		} catch (error) {
			// Don't throw error - this is an optimization, not critical functionality
		}
	}, [aiContextPreloaded, aiChatContext, patientList, filterListData]);

	const renderCard = useCallback((card) => {
		const currentLayout = getCurrentLayout();
		const categories = currentLayout?.categories || [];

		const moveMenuNode = isLayoutMode ? (
			<HospitalMoveMenu
				card={card}
				currentLayout={currentLayout}
				categories={categories}
				onMove={handleMoveCardToCategory}
				onAutoRemoveEmptyCategory={(toTitle) => {
					setToastNotification({
						open: true,
						type: "success",
						title: "Card moved",
						message: `The card was moved to ${toTitle}. The empty category was removed.`,
					});
				}}
			/>
		) : null;

		// Layout-mode fast path: replace the real, data-heavy card bodies with a
		// tiny placeholder that just shows the card's name, keeping the exact same
		// grid footprint (col-4, col-6, col-8, col-12, …). The real cards are
		// still used when NOT editing the layout, and the saved payload is
		// untouched because we only change what is rendered — not the card's id,
		// type, width or position.
		if (isLayoutMode) {
			// Hospital page: render a per-card-type lightweight preview — same UI
			// shape as the real card, but the body is a dummy (typically the same
			// `*Skeleton` component the real card renders while loading) so there
			// are no redux subscriptions, filter math or data fetches during drag.
			// Cards without a dedicated preview fall through to the shared
			// `LayoutPlaceholderCard variant="card"` inside the dispatcher, so
			// every card always renders something and drag/drop never breaks.
			return (
				<HospitalCardLayoutPreview
					card={card}
					dynamicCards={dynamicCards}
					sharedUsersByTabId={sharedUsersByCustomTabId}
				/>
			);
		}

		switch (card.component) {
			case 'hospitalizations':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS}_scroll`} checked={true} style={{ height: isMobile ? `auto` : '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="New Hospitalizations &amp; Re-Hospitalizations"
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS, null, false, defaultTab)}
							tooltipContent={tooltipsInfo.hospitalPage.newHospitalizationANDReHospitalization}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS)}
							cardType={HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS, false)
							}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS,
								data: filterListData?.hospitalizations || [],
								selectedItem: cardFilter?.hospitalizations || [],
							}}
						>
							<HospitalizationsList
								cardTitle="New Hospitalizations &amp; Re-Hospitalizations"
								handleToggle={handleToggle}
								selectedItem={cardFilter.hospitalizations}
								data={filterListData.hospitalizations}
								filter={filter}
								filterComparison={filterComparison}
								dataComparison={filterListDataComparison?.hospitalizations}
								page={PAGE_TYPE.HOSPITAL}
								loading={loading || loadingComparison}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.HOSPITALIZATIONS)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'dcer':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.DCER_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="DC / ER"
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.DCER_DATA, null, false, defaultTab)}
							tooltipContent={tooltipsInfo.hospitalPage["dc/er"]}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DCER_DATA)}
							cardType={HOSPITAL_CARDS_TYPE.DCER_DATA}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.DCER_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.DCER_DATA, false)
							}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.DCER_DATA,
								data: filterListData?.DCERData || [],
								selectedItem: cardFilter?.DCERData || [],
							}}
						>
							<DischargeEmergencyList
								cardTitle="DC / ER"
								handleToggle={handleToggle}
								selectedItem={cardFilter.DCERData}
								data={filterListData.DCERData}
								loading={loading || loadingComparison}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								dataComparison={filterListDataComparison?.DCERData}
								type={HOSPITAL_CARDS_TYPE.DCER_DATA}
								page={PAGE_TYPE.HOSPITAL}
								filter={filter}
								filterComparison={filterComparison}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DCER_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'insurance':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.INSURANCE_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title={HOSPITAL_CARDS_LABELS.insuranceData}
							itemAlign={"ais"}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, HOSPITAL_CARDS_TYPE.INSURANCE_DATA, PATIENT_RELATION.INSURANCE, false, defaultTab)
							}
							tooltipContent={tooltipsInfo.hospitalPage.transfersPerInsurance}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.INSURANCE_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.INSURANCE_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.INSURANCE_DATA, false)
							}
							selectedItems={cardFilter.insuranceData}
							data={filterListData.insuranceData}
							type={HOSPITAL_CARDS_TYPE.INSURANCE_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={HOSPITAL_CARDS_TYPE.INSURANCE_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.INSURANCE_DATA,
								data: filterListData?.insuranceData || [],
								selectedItem: cardFilter?.insuranceData || [],
								labelName: "name"
							}}
						>
							<InsuranceCard
								cardTitle={HOSPITAL_CARDS_LABELS.insuranceData}
								data={filterListData.insuranceData}
								dataComparison={filterListDataComparison?.insuranceData}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								selectedItem={cardFilter.insuranceData}
								type={HOSPITAL_CARDS_TYPE.INSURANCE_DATA}
								page={PAGE_TYPE.HOSPITAL}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								height={300}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.INSURANCE_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'returns':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.RETURNS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="Returned / Didn't Return"
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.RETURNS_DATA, null, false, defaultTab)}
							tooltipContent={tooltipsInfo.hospitalPage["returned/didntReturn"]}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.RETURNS_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.RETURNS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.RETURNS_DATA, false)
							}
							cardType={HOSPITAL_CARDS_TYPE.RETURNS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.RETURNS_DATA,
								data: filterListData?.returnsData || [],
								selectedItem: cardFilter?.returnsData || [],
								labelName: "name"
							}}
						>
							<ReturnCardList
								cardTitle="Returned / Didn't Return"
								handleToggle={handleToggle}
								selectedItem={cardFilter.returnsData}
								transfers={specialComparisonSet ? filterTotal : filterTotal ? filterTotal : dbData.total}
								transfersComparison={specialComparisonSet ? filterTotalComparison : filterTotalComparison ? filterTotalComparison : dbDataComparison?.total}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								type={HOSPITAL_CARDS_TYPE.RETURNS_DATA}
								data={filterListData.returnsData}
								comparisonData={filterListDataComparison?.returnsData}
								page={PAGE_TYPE.HOSPITAL}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.RETURNS_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'ninetyDays':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="90 Days Analysis"
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA, null, false, defaultTab)}
							tooltipContent={tooltipsInfo.hospitalPage["90DaysAnalysis"]}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA, false)
							}
							cardType={HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA,
								data: filterListData?.ninetyDaysData || [],
								selectedItem: cardFilter?.ninetyDaysData || [],
								labelName: "name"
							}}
						>
							{!isMobile ? (
								<NinetyDaysAnalysis
									cardTitle="90 Days Analysis"
									handleToggle={handleToggle}
									loading={loading || loadingComparison}
									selectedItem={cardFilter.ninetyDaysData}
									type={HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA}
									data={filterListData.ninetyDaysData}
									comparisonData={filterListDataComparison?.ninetyDaysData}
									page={PAGE_TYPE.HOSPITAL}
									filterListData={filterListData}
									filterListDataComparison={filterListDataComparison}
									filter={filter}
									filterComparison={filterComparison}
									averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
									}
									height={"100%"}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							) : (
								<FloorCardList
									cardTitle="90 Days Analysis"
									data={filterListData?.ninetyDaysData?.map(item => ({ ...item, total: item.value })) || []}
									dataComparison={filterListDataComparison?.ninetyDaysData?.map(item => ({ ...item, total: item.value })) || []}
									handleToggle={handleToggle}
									handleToggleAll={handleToggleAll}
									loading={loading || loadingComparison}
									selectedItem={cardFilter.ninetyDaysData}
									type={HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA}
									page={PAGE_TYPE.HOSPITAL}
									filter={filter}
									filterComparison={filterComparison}
									averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
									}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.NINETY_DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							)
							}

						</Card>
					</CardAnimation>
				);

			case 'floors':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.FLOORS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title={HOSPITAL_CARDS_LABELS.floorsData}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, HOSPITAL_CARDS_TYPE.FLOORS_DATA, PATIENT_RELATION.UNIT, false, defaultTab)
							}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.FLOORS_DATA,
								data: filterListData?.floorsData || [],
								selectedItem: cardFilter?.floorsData || [],
							}}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.FLOORS_DATA}
									data={filterListData.floorsData}
									selectedItem={cardFilter.floorsData}
								/>
							}
							tooltipContent={tooltipsInfo.hospitalPage.perFloor}
							isMinimized={true}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.FLOORS_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.FLOORS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.FLOORS_DATA, false)
							}
							selectedItems={cardFilter.floorsData}
							data={filterListData.floorsData}
							type={HOSPITAL_CARDS_TYPE.FLOORS_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={HOSPITAL_CARDS_TYPE.FLOORS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>
							<FloorCardList
								cardTitle={HOSPITAL_CARDS_LABELS.floorsData}
								data={filterListData.floorsData}
								dataComparison={filterListDataComparison?.floorsData}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								loading={loading || loadingComparison}
								selectedItem={cardFilter.floorsData}
								type={HOSPITAL_CARDS_TYPE.FLOORS_DATA}
								page={PAGE_TYPE.HOSPITAL}
								filter={filter}
								filterComparison={filterComparison}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.FLOORS_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'doctor':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.DOCTOR_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title={HOSPITAL_CARDS_LABELS.doctorData}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, HOSPITAL_CARDS_TYPE.DOCTOR_DATA, PATIENT_RELATION.DOCTOR, false, defaultTab)
							}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DOCTOR_DATA)}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.DOCTOR_DATA,
								data: filterListData?.doctorData || [],
								selectedItem: cardFilter?.doctorData || [],
								labelName: "name"
							}}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.DOCTOR_DATA}
									data={filterListData.doctorData}
									selectedItem={cardFilter.doctorData}
								/>
							}
							tooltipContent={tooltipsInfo.hospitalPage.perDoctor}
							isMinimized={true}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.DOCTOR_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.DOCTOR_DATA, false)
							}
							selectedItems={cardFilter.doctorData}
							data={filterListData.doctorData}
							type={HOSPITAL_CARDS_TYPE.DOCTOR_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={HOSPITAL_CARDS_TYPE.DOCTOR_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>
							<DoctorCard
								cardTitle={HOSPITAL_CARDS_LABELS.doctorData}
								data={filterListData.doctorData}
								comparisonData={filterListDataComparison?.doctorData}
								minimizable={true}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.doctorData}
								type={HOSPITAL_CARDS_TYPE.DOCTOR_DATA}
								page={PAGE_TYPE.HOSPITAL}
								loading={loading || loadingComparison}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								filter={filter}
								filterComparison={filterComparison}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DOCTOR_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'days':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.DAYS_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title={HOSPITAL_CARDS_LABELS.daysData}
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DAYS_DATA)}
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.DAYS_DATA, null, false, defaultTab)}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.DAYS_DATA}
									data={filterListData.daysData}
									selectedItem={cardFilter.daysData}
								/>
							}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.DAYS_DATA,
								data: filterListData?.daysData || [],
								selectedItem: cardFilter?.daysData || [],
							}}
							tooltipContent={tooltipsInfo.hospitalPage.perDayOfTheWeek}
							isMinimized={true}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.DAYS_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.DAYS_DATA, false)
							}
							cardType={HOSPITAL_CARDS_TYPE.DAYS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>

							{!isMobile ? (
								<DayCardList
									cardTitle={HOSPITAL_CARDS_LABELS.daysData}
									data={filterListData.daysData}
									dataComparison={filterListDataComparison?.daysData}
									handleToggle={handleToggle}
									selectedItem={cardFilter.daysData}
									filter={filter}
									loading={loading || loadingComparison}
									filterComparison={filterComparison}
									type={HOSPITAL_CARDS_TYPE.DAYS_DATA}
									page={PAGE_TYPE.HOSPITAL}
									averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
									}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							) : (
								<FloorCardList
									cardTitle={HOSPITAL_CARDS_LABELS.daysData}
									data={filterListData?.daysData?.map(item => ({ ...item, total: item.value })) || []}
									dataComparison={filterListDataComparison?.daysData?.map(item => ({ ...item, total: item.value })) || []}
									handleToggle={handleToggle}
									handleToggleAll={handleToggleAll}
									loading={loading || loadingComparison}
									selectedItem={cardFilter.daysData}
									type={HOSPITAL_CARDS_TYPE.DAYS_DATA}
									page={PAGE_TYPE.HOSPITAL}
									filter={filter}
									filterComparison={filterComparison}
									averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
									averageCensusComparison={
										specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
									}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							)}
						</Card>
					</CardAnimation>
				);

			case 'dx':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.DX_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="Per Diagnosis"
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DX_DATA)}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, HOSPITAL_CARDS_TYPE.DX_DATA, PATIENT_RELATION.DX, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.DX_DATA}
									data={filterListData.dxData}
									selectedItem={cardFilter.dxData}
								/>
							}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.DX_DATA,
								data: filterListData?.dxData || [],
								selectedItem: cardFilter?.dxData || [],
							}}
							tooltipContent={tooltipsInfo.hospitalPage.perDiagnosis}
							isMinimized={true}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.DX_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.DX_DATA, false)
							}
							selectedItems={cardFilter.dxData}
							data={filterListData.dxData}
							type={HOSPITAL_CARDS_TYPE.DX_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={HOSPITAL_CARDS_TYPE.DX_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>
							<DiagnosticsCardList
								cardTitle="Per Diagnosis"
								data={filterListData.dxData}
								dataComparison={filterListDataComparison?.dxData}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.dxData}
								type={HOSPITAL_CARDS_TYPE.DX_DATA}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								page={PAGE_TYPE.HOSPITAL}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.DX_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'shift':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.SHIFT_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="Per Shift"
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.SHIFT_DATA)}
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.SHIFT_DATA, null, false, defaultTab)}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.SHIFT_DATA}
									data={filterListData.shiftData}
									selectedItem={cardFilter.shiftData}
								/>
							}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.SHIFT_DATA,
								data: filterListData?.shiftData || [],
								selectedItem: cardFilter?.shiftData || [],
							}}
							isMinimized={true}
							tooltipContent={tooltipsInfo.hospitalPage.perShift}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.SHIFT_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.SHIFT_DATA, false)
							}
							cardType={HOSPITAL_CARDS_TYPE.SHIFT_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>
							<ShiftCard
								cardTitle="Per Shift"
								data={filterListData.shiftData}
								dataComparison={filterListDataComparison?.shiftData}
								handleToggle={handleToggle}
								selectedItem={cardFilter.shiftData}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								type={HOSPITAL_CARDS_TYPE.SHIFT_DATA}
								page={PAGE_TYPE.HOSPITAL}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.SHIFT_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'nurse':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.NURSE_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="Per Nurse"
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.NURSE_DATA)}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, HOSPITAL_CARDS_TYPE.NURSE_DATA, PATIENT_RELATION.NURSE, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.NURSE_DATA}
									data={filterListData.nurseData}
									selectedItem={cardFilter.nurseData}
								/>
							}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.NURSE_DATA,
								data: filterListData?.nurseData || [],
								selectedItem: cardFilter?.nurseData || [],
							}}
							tooltipContent={tooltipsInfo.hospitalPage.perNurse}
							isMinimized={true}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.NURSE_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.NURSE_DATA, false)
							}
							selectedItems={cardFilter.nurseData}
							data={filterListData.nurseData}
							type={HOSPITAL_CARDS_TYPE.NURSE_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={HOSPITAL_CARDS_TYPE.NURSE_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>
							<DoctorCard
								cardTitle="Per Nurse"
								data={filterListData.nurseData}
								comparisonData={filterListDataComparison?.nurseData}
								minimizable={true}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.nurseData}
								type={HOSPITAL_CARDS_TYPE.NURSE_DATA}
								page={PAGE_TYPE.HOSPITAL}
								loading={loading || loadingComparison}
								averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
								averageCensusComparison={
									specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
								}
								filter={filter}
								filterComparison={filterComparison}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.NURSE_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'hospital':
				return (
					<CardAnimation id={`${HOSPITAL_CARDS_TYPE.HOSPITAL_DATA}_scroll`} checked={true} style={{ height: '100%' }}>
						<Card
							isDebug={true}
							pageType={PAGE_TYPE.HOSPITAL}
							loading={loading || loadingComparison}
							title="Hospitals residents transferred to"
							priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.HOSPITAL_DATA)}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, HOSPITAL_CARDS_TYPE.HOSPITAL_DATA, PATIENT_RELATION.HOSPITAL, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={HOSPITAL_CARDS_TYPE.HOSPITAL_DATA}
									data={filterListData.hospitalData}
									selectedItem={cardFilter.hospitalData}
									labelName="name"
								/>
							}
							filterMenuData={{
								type: HOSPITAL_CARDS_TYPE.HOSPITAL_DATA,
								data: filterListData?.hospitalData || [],
								selectedItem: cardFilter?.hospitalData || [],
							}}
							tooltipContent={tooltipsInfo.hospitalPage.hospitalResidentsTransferred}
							isSlider={true}
							isMinimized={true}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(HOSPITAL_CARDS_TYPE.HOSPITAL_DATA, title, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.HOSPITAL_DATA, false)
							}
							selectedItems={cardFilter.hospitalData}
							data={filterListData.hospitalData}
							type={HOSPITAL_CARDS_TYPE.HOSPITAL_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={HOSPITAL_CARDS_TYPE.HOSPITAL_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
							headerActions={moveMenuNode}
						>
							<>
								{isMobile && (
									<HospitalList
										dbData={dbData}
										dbDataComparison={dbDataComparison}
										cardTitle="Per Hospital"
										total={dbData.total}
										totalComparison={dbDataComparison?.total}
										data={filterListData.hospitalData}
										dataComparison={filterListDataComparison?.hospitalData}
										filter={filter}
										filterComparison={filterComparison}
										handleToggle={handleToggle}
										selectedItem={cardFilter.hospitalData}
										type={HOSPITAL_CARDS_TYPE.HOSPITAL_DATA}
										page={PAGE_TYPE.HOSPITAL}
										loading={loading || loadingComparison}
										comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
										projectionDays={projectionDays}
										filterTotal={filterTotal}
										averageCensus={percentageAgainst}
										priorityData={cardFilter.mainPriorityData}
										priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.HOSPITAL_DATA)}
										transferType={transferType}
										lockedTotalBy={lockedTotalBy}
										disableInteractions={isLayoutMode}
										isMobile={isMobile}
									/>
								)}
								{!isMobile && filterListData?.hospitalData && filterListData?.hospitalData?.length > 0 && (
									<HospitalSlider
										cardTitle="Hospitals residents transferred to"
										data={filterListData.hospitalData}
										dataComparison={filterListDataComparison?.hospitalData}
										minimizable={true}
										handleToggle={handleToggle}
										handleToggleAll={handleToggleAll}
										filter={filter}
										filterCommaprison={filterComparison}
										selectedItem={cardFilter.hospitalData}
										type={HOSPITAL_CARDS_TYPE.HOSPITAL_DATA}
										isDetailsOpen={true}
										loading={loading || loadingComparison}
										totalTransfers={dbData.total}
										totalTransfersComparison={dbDataComparison?.total}
										projectionDays={projectionDays}
										filterTotal={filterTotal}
										averageCensus={specialComparisonSet ? filterTotal : getPercentageByTotal(dbData)}
										averageCensusComparison={
											specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
										}
										isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
										priorityNumber={getPriorityNumber(HOSPITAL_CARDS_TYPE.HOSPITAL_DATA)}
										transferType={transferType}
										lockedTotalBy={lockedTotalBy}
										disableInteractions={isLayoutMode}
										isMobile={isMobile}
									/>
								)}
							</>
						</Card>
					</CardAnimation>
				);

			case 'dynamic':
				return (
					<DynamicCardItem
						headerActions={moveMenuNode}
						disableInteractions={isLayoutMode}
						filterTotal={filterTotal}
						key={card.data?.accessor || Math.random()}
						ele={card.data}
						pageType={PAGE_TYPE.HOSPITAL}
						isCustomTab={card.data?.isCustomTab || false}
						selectedCards={hospitalCards}
						loading={loading}
						loadingComparison={loadingComparison}
						filterListData={filterListData}
						filterListDataComparison={filterListDataComparison}
						cardFilter={cardFilter}
						handleChartDialog={handleChartDialog}
						handleOnClickReport={handleOnClickReport}
						handleOnClickShareReport={handleOnClickShareReport}
						handleToggle={handleToggle}
						handleToggleAll={handleToggleAll}
						filter={filter}
						filterComparison={filterComparison}
						dbData={dbData}
						dbDataComparison={dbDataComparison}
						percentageAgainst={percentageAgainst}
						projectionDays={projectionDays}
						getPriorityNumber={getPriorityNumber}
						transferType={transferType}
						lockedTotalBy={lockedTotalBy}
						page={PAGE_TYPE.HOSPITAL}
						averageCensusComparison={
							specialComparisonSet ? filterTotalComparison : getPercentageByTotal(dbDataComparison)
						}
						sharedUsersByTabId={sharedUsersByCustomTabId}
						sharedWithEveryoneByTabId={sharedWithEveryoneByTabId}
					/>
				);

			default:
				return null;
		}
	}, [isMobile, loading, loadingComparison, getPriorityNumber, handleToggle, cardFilter, filterListData, filter, filterComparison, filterListDataComparison, specialComparisonSet, filterTotal, dbData, filterTotalComparison, dbDataComparison, projectionDays, transferType, lockedTotalBy, handleToggleAll, percentageAgainst, comparingAgainstDifferentFacility, hospitalCards, handleChartDialog, handleOnClickReport, handleOnClickShareReport, isLayoutMode, getCurrentLayout, handleMoveCardToCategory, setToastNotification, sharedUsersByCustomTabId, sharedWithEveryoneByTabId, dynamicCards]);

	return (
		<Page title="Dashboard: Hospital">
			{detailsDialog.isOpen && (
				<HospitalCardDetailsDialog
					handleOnClickReport={handleOnClickReportGraph}
					handleOnClickShareReport={handleOnClickShareReport}
					handleGenerateExcelReport={downloadExcel}
				/>
			)}

			<div
				id="scroll-container"
				ref={scrollDemoRef}
				className={dashboardStyles.content}
				onScroll={handleScroll}
				style={{
					position: 'relative',
					// Layout-mode zoom wrapper expands past 100% then scales down; clip
					// any sub-pixel horizontal bleed without adding a permanent scrollbar.
					...(isLayoutMode ? { overflowX: 'hidden' } : {}),
				}}
			>
				{/* Layout Type Loading Overlay */}
				{layoutTypeLoading && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(255, 255, 255, 0.9)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 99999,
						flexDirection: 'column',
						gap: '16px'
					}}>
						<CircularProgress size={40} />
						<div style={{ fontSize: '16px', color: '#333', fontWeight: '500' }}>Loading layout...</div>
					</div>
				)}

				{!isLayoutMode && (
					<div className={`df aic ${styles.header}`} id="headerOffset" style={{ position: 'relative' }}>
						<div className={`df aic ${styles.aoWrapper}`}>
							<HospitalHeader
								isHeaderVisible={isHeaderVisible}
								setIsHeaderVisible={setIsHeaderVisible}
								isLayoutMode={isLayoutMode}
								filterListData={filterListData}
								handleFilterUpdate={() => setIsDateUpdated(true)}
								loading={loading || loadingComparison}
								setLoading={setLoading}
								setLoadingComparison={setLoadingComparison}
								isOnlyHospitalDashboard={isOnlyHospitalDashboard}
								filter={filter}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								percentageAgainst={percentageAgainst}
								dynamicCards={[...(dynamicCards || []), ...(patientList?.customTabs || [])]}
								disableInteractions={isLayoutMode}
								isDataFromCache={isDataFromCache}
								renderCardFilterPopover={renderHospitalCardFilterPopover}
								interactiveHeaderFilterPopoverSlowTransition
								pageConverterPatientList={
									pageConverterPatientSource !== null
										? pageConverterPatientSource
										: Array.isArray(patientList?.list)
											? patientList.list
											: []
								}
								pageConverterFilter={filter}
							/>
						</div>

						{/* Sync Status Indicator for Super Admins */}
						{isSuperUser && (
							<Tooltip
								title={
									syncPreference
										? "Your personal layout automatically syncs with the default layout"
										: "Your personal layout is independent of the default layout"
								}
								arrow
							>
								<Box
									sx={{
										position: 'absolute',
										top: '10px',
										right: '20px',
										display: 'flex',
										alignItems: 'center',
										gap: 1,
										backgroundColor: 'rgba(255, 255, 255, 0.9)',
										padding: '4px 8px',
										borderRadius: '4px',
										fontSize: '12px',
										color: 'text.secondary',
										zIndex: 1,
										cursor: 'help'
									}}
								>
									{syncLoading ? (
										<>
											<CircularProgress size={12} />
											<span>Loading sync...</span>
										</>
									) : (
										<>
											<Box
												sx={{
													width: 8,
													height: 8,
													borderRadius: '50%',
													backgroundColor: syncPreference ? 'success.main' : 'grey.400'
												}}
											/>
											<span>
												Auto-sync: {syncPreference ? 'Enabled' : 'Disabled'}
											</span>
											<IconButton
												size="small"
												onClick={refetchSyncPreference}
												disabled={syncLoading}
												sx={{
													padding: '2px',
													'&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
												}}
											>
												<RefreshIcon fontSize="small" />
											</IconButton>
										</>
									)}
								</Box>
							</Tooltip>
						)}
					</div>
				)}
				{(loading || hospitalLoading) ? (
					<div style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "90vh"
					}}>
						<CircularProgress />
					</div>
				) : (
					<Box
						ref={layoutZoomWrapperRef}
						sx={{
							...(isLayoutMode
								? {
									// Stronger zoom on desktop; slightly less on mobile for tap targets.
									// L/R gaps (before): `transform-origin: top center` shrinks the paint
									// toward the middle while the layout box stays full-width → empty bands.
									// Fix: `top left` + logical width `calc(100%/z)` so scaled content uses
									// the full content width.
									transform: `scale(${isMobile ? HOSPITAL_LAYOUT_MODE_ZOOM_MOBILE : HOSPITAL_LAYOUT_MODE_ZOOM_DESKTOP})`,
									transformOrigin: 'top left',
									width: `calc(100% / ${isMobile ? HOSPITAL_LAYOUT_MODE_ZOOM_MOBILE : HOSPITAL_LAYOUT_MODE_ZOOM_DESKTOP})`,
									maxWidth: 'none',
									transition: 'transform 0.22s ease-out, width 0.22s ease-out',
									willChange: 'transform',
								}
								: {}),
						}}
					>
						<NoteContainer page={PAGE_TYPE.HOSPITAL} isMobile={isMobile} isHeaderVisible={isHeaderVisible}>
							<Grid container justifyContent={"center"} sx={{ mt: "30px" }}>
								{rangesSet && !isMobile && <ColorInfoBox style={{ right: "3%" }} loading={loading || loadingComparison} isLayoutMode={isLayoutMode} />}
								<Grid item xs={12} position={"relative"}>
									{!isMobile && (
										<AddCardDrawer
											listData={isOnlyHospitalDashboard ? HOSPITAL_CUSTOM_CARD_DATA?.filter(ele => ele.value !== HOSPITAL_CARDS_TYPE.RETURNS_DATA) : HOSPITAL_CUSTOM_CARD_DATA}
											selectedCards={hospitalCards}
											handleAddCustomCard={handleAddCustomCard}
											scrollTop={scrollPosition?.scrollTop}
											filter={filter}
											isLayoutMode={isLayoutMode}
											pinTopInLayoutMode={true}
											prepareScrollToCard={prepareScrollToCard}
										/>
									)}
									<TotalCountCircle
										isHeaderVisible={isHeaderVisible}
										isLayoutMode={isLayoutMode}
										loading={loading || loadingComparison}
										page={PAGE_TYPE.HOSPITAL}
										totalTitle={`Total Hospital Transfers`}
										projectTitle={percentageBy}
										selected={transferType === TYPES.ALL}
										filter={filter}
										filterComparison={filterComparison}
										handleClickTotal={() => {
											triggerFilterTutorial();
											handleClickTotal(calcProPercentsBasedOnFilterAndDays(dbData.total, filter, projectionDays));
										}}
										total={dbData.total}
										totalComparison={dbDataComparison?.total}
										totalPercentage={itemPercentage(dbData.total, percentageAgainst, "number")}
										projectTotal={projectionPerMonth(dbData.total, filter, projectionDays)}
										projectTotalComparison={projectionPerMonth(dbDataComparison?.total, filterComparison, projectionDays)}
										totalProjectionPercentage={itemPercentage(
											projectionPerMonth(dbData.total, filter, projectionDays),
											percentageAgainst,
											"number"
										)}
										tooltipContent={tooltipsInfo.hospitalPage.totalHospitalization}
										handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.TOTAL, null, true, defaultTab)}
										totalComparisonPercentage={itemPercentage(
											dbDataComparison?.total,
											getPercentageByTotal(dbDataComparison),
											"number"
										)}
										totalProjectionComparisonPercentage={itemPercentage(
											projectionPerMonth(dbDataComparison?.total, filterComparison),
											getPercentageByTotal(dbDataComparison),
											"number"
										)}
										handleOnClickReport={(title, otherData) => handleOnClickReport(HOSPITAL_CARDS_TYPE.TOTAL, title, true, otherData)}
										handleOnClickShareReport={(title) => handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.TOTAL, true)}
										projectionDays={projectionDays}
										totalCardType={"total"}
										isMobile={isMobile}
									/>
								</Grid>
							</Grid>
							<Box sx={{ p: 2, pl: 2, pr: 2 }}>
								{/* Transfer Type Selection */}
								<Grid container spacing={isMobile ? 0 : 2} direction={"row"} display="flex" justifyContent="center">
									<Grid item xs={6} sm={6} md={6}>
										<SelectableCard
											isLayoutMode={isLayoutMode}
											pageType={PAGE_TYPE.HOSPITAL}
											loading={loading || loadingComparison}
											title="Unplanned Transfers"
											disabled={isLayoutMode || transferType === TYPES.PLANNED}
											selected={transferType === TYPES.UNPLANNED}
											handleOnclickCard={() => {
												triggerFilterTutorial();
												handleOnclickCard(TYPES.UNPLANNED, dbData.unplannedHospitalTransfer, dbData.total)
											}}
											handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.UNPLANNED, null, true, defaultTab)}
											tooltipContent={tooltipsInfo.hospitalPage.unplannedHosspitalTransfers}
											handleOnClickReport={(title, otherData) =>
												handleOnClickReport(HOSPITAL_CARDS_TYPE.UNPLANNED, title, true, otherData)
											}
											handleOnClickShareReport={(title) =>
												handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.UNPLANNED, true)
											}
											isMobile={isMobile}

										>
											<TotalTransferCard
												loading={loading || loadingComparison}
												page={PAGE_TYPE.HOSPITAL}
												title={"Total Hospital Transfers"}
												total={dbData.unplannedHospitalTransfer}
												totalComparison={dbDataComparison?.unplannedHospitalTransfer}
												totalPercentage={itemPercentage(dbData.unplannedHospitalTransfer, percentageAgainst, "number")}
												totalProjection={projectionPerMonth(dbData.unplannedHospitalTransfer, filter, projectionDays)}
												totalProjectionComparison={projectionPerMonth(
													dbDataComparison?.unplannedHospitalTransfer,
													filterComparison,
													projectionDays
												)}
												totalProjectionPercentage={itemPercentage(
													projectionPerMonth(dbData.unplannedHospitalTransfer, filter, projectionDays),
													percentageAgainst,
													"number"
												)}
												filter={filter}
												filterComparison={filterComparison}
												secondaryTitle={percentageBy}
												secondaryText={""}
												totalComparisonPercentage={itemPercentage(
													dbDataComparison?.unplannedHospitalTransfer,
													getPercentageByTotal(dbDataComparison),
													"number"
												)}
												totalProjectionComparisonPercentage={itemPercentage(
													projectionPerMonth(dbDataComparison?.unplannedHospitalTransfer, filterComparison, projectionDays),
													getPercentageByTotal(dbDataComparison),
													"number"
												)}
												projectionDays={projectionDays}
												isMobile={isMobile}
											/>
										</SelectableCard>
									</Grid>
									<Grid item xs={6} sm={6} md={6}>
										<SelectableCard
											isLayoutMode={isLayoutMode}
											pageType={PAGE_TYPE.HOSPITAL}
											flex="1"
											loading={loading || loadingComparison}
											title="Planned Transfers"
											disabled={isLayoutMode || transferType === TYPES.UNPLANNED}
											selected={transferType === TYPES.PLANNED}
											handleOnclickCard={() => {
												triggerFilterTutorial();
												handleOnclickCard(TYPES.PLANNED, dbData.plannedHospitalTransfer, dbData.total)
											}}
											handleOnClickAction={(title, defaultTab) => handleChartDialog(title, HOSPITAL_CARDS_TYPE.PLANNED, null, true, defaultTab)}
											tooltipContent={tooltipsInfo.hospitalPage.plannedHospitalTransfers}
											handleOnClickReport={(title, otherData) =>
												handleOnClickReport(HOSPITAL_CARDS_TYPE.plannedHospitalTransfer, title, true, otherData)
											}
											handleOnClickShareReport={(title) =>
												handleOnClickShareReport(title, HOSPITAL_CARDS_TYPE.PLANNED, true)
											}
											isMobile={isMobile}
											lastCard={true}
										>
											<TotalTransferCard
												loading={loading || loadingComparison}
												page={PAGE_TYPE.HOSPITAL}
												filter={filter}
												filterComparison={filterComparison}
												title={"Total Hospital Transfers"}
												total={dbData.plannedHospitalTransfer}
												totalComparison={dbDataComparison?.plannedHospitalTransfer}
												totalPercentage={itemPercentage(dbData.plannedHospitalTransfer, percentageAgainst, "number")}
												totalProjection={projectionPerMonth(dbData.plannedHospitalTransfer, filter, projectionDays)}
												totalProjectionComparison={projectionPerMonth(
													dbDataComparison?.plannedHospitalTransfer,
													filterComparison,
													projectionDays
												)}
												totalProjectionPercentage={itemPercentage(
													projectionPerMonth(dbData.plannedHospitalTransfer, filter, projectionDays),
													percentageAgainst,
													"number"
												)}
												secondaryTitle={percentageBy}
												secondaryText={""}
												totalComparisonPercentage={itemPercentage(
													dbDataComparison?.plannedHospitalTransfer,
													getPercentageByTotal(dbDataComparison),
													"number"
												)}
												totalProjectionComparisonPercentage={itemPercentage(
													projectionPerMonth(dbDataComparison?.plannedHospitalTransfer, filterComparison, projectionDays),
													getPercentageByTotal(dbDataComparison),
													"number"
												)}
												projectionDays={projectionDays}
												isMobile={isMobile}
											/>
										</SelectableCard>
									</Grid>

									{!isMobile && <ShadowLineWithText data={hospitalCards} />}

									{/* End of Transfer Type Selection */}

									<Box sx={{ width: '100%', mt: 2, mb: 2, pb: 1 }}>
										{(() => {
											const lo = getCurrentLayout();
											const { layoutForDrag, cardsForGrid } = hospitalMainGridPayload;
											const hasRoot =
												(lo.categories?.length || 0) + (lo.standalone?.length || 0) > 0;
											if (!isLayoutMode && (!hasRoot || cardsForGrid.length === 0)) return null;
											const categoryIdSet = new Set((lo.categories || []).map((c) => c.id));
											const hasStandaloneCards = (lo.standalone?.length || 0) > 0;
											const showStandaloneFallbackDropZone =
												isLayoutMode &&
												!hasStandaloneCards &&
												(Boolean(draggedCardId) || Boolean(draggedCardIdRef.current)) &&
												dragSource &&
												dragSource !== "standalone";

											return (
												<>
													<DragDropLayout
														isBoundedLayout={true}
														cards={cardsForGrid}
														layout={layoutForDrag}
														onLayoutChange={handleRootGridChange}
														isLayoutMode={isLayoutMode}
														disabled={loading || hospitalLoading}
														isMobile={isMobile}
														uniformCardHeight={false}
														strictOverlapReorder
														strictOverlapThreshold={0.62}
														draggableCancel=".hospital-category-inner-dnd"
														hospitalRootLayoutMarker
														enableRootGaps={isLayoutMode}
														onRootGapDrop={handleRootGapDrop}
														layoutScrollContainerRef={scrollDemoRef}
														// Layout mode zooms the entire dashboard via
														// `transform: scale(...)`. RGL must know the
														// scale so its drag math stays 1:1 with the
														// cursor — otherwise the dragged card drifts
														// ~(1/scale - 1) px per px of drag, ending up
														// 100–200 px away from the cursor by the
														// bottom of a long page.
														transformScale={
															isLayoutMode
																? (isMobile
																	? HOSPITAL_LAYOUT_MODE_ZOOM_MOBILE
																	: HOSPITAL_LAYOUT_MODE_ZOOM_DESKTOP)
																: 1
														}
														generalDropHighlight={hospitalGeneralDropHighlight}
														shouldPersistLayoutAfterDrag={() => {
															if (!isLayoutMode) return true;
															const dragging =
																draggedCardId || draggedCardIdRef.current;
															if (dragging && hoveredCategoryId != null) return false;
															return true;
														}}
														onDragStart={(layout, oldItem, newItem) => {
															const id = newItem?.i;
															if (!id) return;
															if (categoryIdSet.has(id)) {
																draggedCardIdRef.current = null;
																dragSourceRef.current = null;
																setDraggedCardId(null);
																setDragSource(null);
																setHoveredCategoryId(null);
																setHoveredStandalone(false);
																return;
															}
															draggedCardIdRef.current = id;
															dragSourceRef.current = "standalone";
															setDraggedCardId(id);
															setDragSource("standalone");
															setHoveredCategoryId(null);
															setHoveredStandalone(true);
														}}
														onDragStop={(layout, oldItem, newItem, placeholder, e) => {
															// Bulletproof Drop: Use the exact coordinates at release to find the target.
															const pt = getPointerClientCoords(e);
															let targetId = hoveredCategoryId;

															if (pt) {
																const cid = resolveHospitalCategoryIdUnderPointer(pt.x, pt.y);
																if (cid) targetId = cid;
															}

															if (targetId != null) {
																handleCardDrop(targetId, "General Cards", e);
															}

															setTimeout(() => {
																draggedCardIdRef.current = null;
																dragSourceRef.current = null;
																setDraggedCardId(null);
																setHoveredCategoryId(null);
																setHoveredStandalone(false);
																setDragSource(null);
															}, 50);
														}}
													>
														{(gridCard) => {
															if (gridCard.type === "category") {
																const category = lo.categories.find((c) => c.id === gridCard.id);
																if (!category) return null;
																const categoryCards = (category.cards || [])
																	.map((cardItem) => {
																		const def = cardData.find((c) => c.id === cardItem.id);
																		return def ? { ...def, ...cardItem } : null;
																	})
																	.filter(Boolean);
																return (
																	<CategoryBox
																		id={category.id}
																		title={category.title}
																		cards={categoryCards}
																		dynamicCards={[...(dynamicCards || []), ...(patientList?.customTabs || [])]}
																		isCollapsed={Boolean(collapsedCategoryIds[category.id])}
																		onToggleCollapse={handleToggleCategoryCollapse}
																		onLayoutChange={handleLayoutChangeInCategory}
																		onDelete={handleDeleteCategory}
																		onUpdateTitle={handleUpdateCategoryTitle}
																		renderCard={renderCard}
																		isLayoutMode={isLayoutMode}
																		loading={loading || hospitalLoading}
																		isMobile={isMobile}
																		innerTwoColumnDesktop={categoryInnerTwoCol}
																		layoutScrollContainerRef={scrollDemoRef}
																		useNativeCategoryReorder={false}
																		transformScale={
																			isLayoutMode
																				? (isMobile
																					? HOSPITAL_LAYOUT_MODE_ZOOM_MOBILE
																					: HOSPITAL_LAYOUT_MODE_ZOOM_DESKTOP)
																				: 1
																		}
																		onMouseEnter={(cid) => {
																			setHoveredCategoryId(cid);
																			setHoveredStandalone(false);
																		}}
																		onMouseLeave={() => setHoveredCategoryId(null)}
																		draggedCardId={draggedCardId}
																		dragSourceId={dragSource}
																		hoveredCategoryId={hoveredCategoryId}
																		hoveredStandalone={hoveredStandalone}
																		suppressCategoryInnerPersistRef={suppressCategoryInnerPersistRef}
																		onInnerLayoutDrag={(layout, oldItem, newItem, placeholder, ev) => {
																			const c = getPointerClientCoords(ev);
																			if (c) categoryDragPointerRef.current = c;
																		}}
																		onDragStart={(cardId, sourceCategoryId) => {
																			categoryDragPointerRef.current = null;
																			draggedCardIdRef.current = cardId;
																			dragSourceRef.current = sourceCategoryId;
																			setDraggedCardId(cardId);
																			setDragSource(sourceCategoryId);
																			setHoveredCategoryId(null);
																			setHoveredStandalone(false);
																		}}
																		onDragStop={(cardId, sourceCategoryId, e) => {
																			// Fix 3: Enhanced pointer coordinate fallback chain
																			const pt =
																				getPointerClientCoords(e) ||
																				categoryDragPointerRef.current ||
																				(Date.now() - lastPointerRef.current.timestamp < 500
																					? lastPointerRef.current
																					: null);
																			let droppedOnStandalone = false;
																			const zoneEl = standaloneDropZoneRef.current;
																			if (pt && zoneEl) {
																				const r = zoneEl.getBoundingClientRect();
																				if (pointInRect(pt, r)) {
																					droppedOnStandalone = true;
																				}
																			}
																			if (!droppedOnStandalone && pt) {
																				// Fix 3: Try nearby points if elementFromPoint fails at exact location
																				let el = document.elementFromPoint(pt.x, pt.y);
																				if (!el?.closest?.("[data-hospital-drop='standalone']")) {
																					const offsets = [[5, 0], [-5, 0], [0, 5], [0, -5]];
																					for (const [dx, dy] of offsets) {
																						el = document.elementFromPoint(pt.x + dx, pt.y + dy);
																						if (el?.closest?.("[data-hospital-drop='standalone']")) break;
																					}
																				}
																				if (el?.closest?.("[data-hospital-drop='standalone']")) {
																					droppedOnStandalone = true;
																				}
																			}
																			if (!droppedOnStandalone && hoveredStandaloneRef.current) {
																				droppedOnStandalone = true;
																			}
																			if (!droppedOnStandalone && pt && pointerOverHospitalRootStandaloneArea(pt)) {
																				droppedOnStandalone = true;
																			}
																			categoryDragPointerRef.current = null;
																			// Geometric lookup for the destination category at the drop point.
																			// The hoveredCategoryId state alone is unreliable for category-to-category
																			// drops: depending on the direction of travel (e.g. dragging upward from
																			// a lower category to a higher one), the destination's mouseenter can
																			// arrive after React has already captured the onDragStop closure, leaving
																			// hoveredCategoryId stale/null. Falling back to elementFromPoint at the
																			// real pointer location (with small-offset retries to survive the dragged
																			// card ghost or tiny anti-aliasing gaps) makes drops work in every
																			// direction regardless of mouseenter timing.
																			const geometricTargetCategoryId =
																				!droppedOnStandalone && pt
																					? resolveHospitalCategoryIdUnderPointer(pt.x, pt.y)
																					: null;
																			if (droppedOnStandalone) {
																				suppressCategoryInnerPersistRef.current = true;
																				handleCardDrop("standalone", "General Cards", e);
																			} else if (
																				geometricTargetCategoryId != null &&
																				geometricTargetCategoryId !== category.id
																			) {
																				// Geometric drop wins over stale hover state — the pointer is
																				// definitively over another category's Paper.
																				suppressCategoryInnerPersistRef.current = true;
																				handleCardDrop(geometricTargetCategoryId, "General Cards", e);
																			} else if (hoveredCategoryId != null && hoveredCategoryId !== category.id) {
																				// Support direct category-to-category drops by checking hovered state at drag end.
																				suppressCategoryInnerPersistRef.current = true;
																				handleCardDrop(hoveredCategoryId, "General Cards", e);
																			} else {
																				setTimeout(() => {
																					draggedCardIdRef.current = null;
																					dragSourceRef.current = null;
																					setDraggedCardId(null);
																					setHoveredCategoryId(null);
																					setHoveredStandalone(false);
																					setDragSource(null);
																				}, 50);
																			}
																			queueMicrotask(() => {
																				suppressCategoryInnerPersistRef.current = false;
																			});
																		}}
																		onCardDrop={() => handleCardDrop(category.id, category.title)}
																		onCardDropAtEdge={handleCardDropAtCategoryEdge}
																		isCardOver={hoveredCategoryId === category.id}
																		showDropSuccessFlash={dropFlashCategoryId === category.id}
																	/>
																);
															}
															return renderCard(gridCard);
														}}
													</DragDropLayout>
													{showStandaloneFallbackDropZone && (
														<Box
															ref={standaloneDropZoneRef}
															data-hospital-drop="standalone"
															onMouseEnter={() =>
																(draggedCardId || draggedCardIdRef.current) &&
																setHoveredStandalone(true)
															}
															onMouseLeave={() => setHoveredStandalone(false)}
															onMouseUp={(ev) => handleCardDrop("standalone", "General Cards", ev)}
															sx={{
																mb: 2,
																ml: 1,
																mt: 1,
																px: 1,
																py: 2,
																minHeight: 88,
																position: "relative",
																zIndex: 10,
																border: "1px dashed rgba(224, 228, 234, 0.95)",
																borderRadius: "8px",
																backgroundColor: "rgba(250, 251, 252, 0.95)",
															}}
														>
															<Typography variant="body2" color="text.secondary" align="center">
																Drop here to move a card to the general area (no general cards in the grid
																yet)
															</Typography>
														</Box>
													)}
												</>
											);
										})()}
									</Box>
								</Grid>
								{/* Dynamic cards are now integrated into the main DragDropLayout above */}
							</Box>
						</NoteContainer>
					</Box>
				)}
			</div>

			{/* Share Notification Dialog for Hospital Page */}
			<ShareNotificationDialog
				open={showShareDialog && !mobileMenuOpen}
				notifications={shareNotifications}
				onClose={handleCloseShareDialog}
				onResponse={handleNotificationResponse}
				onViewTab={handleViewTab}
			/>

			{/* Layout Controller for Drag-and-Drop */}
			<LayoutController
				isLayoutMode={isLayoutMode}
				onToggleLayoutMode={handleToggleLayoutMode}
				onSaveLayout={handleSaveLayout}
				onResetLayout={handleResetLayout}
				onLayoutTypeChange={handleLayoutTypeChange}
				currentLayoutType={currentLayoutType}
				hasChanges={hasLayoutChanges}
				disabled={loading || hospitalLoading}
				pageType={PAGE_TYPE.HOSPITAL}
				onCreateCategory={handleCreateCategory}
				onAddCategoryFromMenu={handleAddCategoryFromMenu}
			/>

			{/* Toast Notification */}
			<ToastNotification
				open={toastNotification.open}
				type={toastNotification.type}
				title={toastNotification.title}
				message={toastNotification.message}
				onClose={() => setToastNotification({ ...toastNotification, open: false })}
			/>

			{/* AI Chat Float Button - Only show when drawer is closed or maximized and user has access */}
			{hasAiChatAccess && !aiChatAccessLoading && !isLayoutMode && (!aiChatOpen || !aiChatMinimized) && (
				<AiChatFloatButton
					onClick={handleAiChatToggle}
					isOpen={aiChatOpen}
					unreadCount={aiChatUnreadCount}
					disabled={loading || hospitalLoading || !dbData}
					showPulse={!loading && !hospitalLoading && dbData && !aiChatOpen}
					tooltipText="Ask AI about your hospital transfer data"
				/>
			)}

			{/* AI Chat Drawer - Only show if user has access */}
			{hasAiChatAccess && !aiChatAccessLoading && (
				<AiChatDrawer
					open={aiChatOpen}
					onClose={handleAiChatClose}
					pageType={PAGE_TYPE.HOSPITAL}
					pageData={aiChatContext}
					onMinimizeStateChange={handleAiChatMinimizeStateChange}
					handleOnClickReport={handleOnClickReport}
					downloadExcel={downloadExcel}
					conversationId={aiConversationId}
					contextPreloaded={aiContextPreloaded}
					filter={filter}
					disabled={loading || hospitalLoading || !dbData}
					loadingMessage={loading || hospitalLoading ? "Loading hospital data... Please wait before asking questions." : undefined}
				/>
			)}
			{/* Debug: Log conversation ID when drawer opens */}

			{/* Share Report Dialog */}
			{shareReportState.open && (
				<ShareNotesDialog
					handleClose={handleCloseShareReport}
					handleSubmit={handleShareReport}
					isShare={shareReportState.open}
					noteText={`Report: ${shareReportState.reportTitle || 'Generated Report'}`}
					users={users}
					availableIntegrations={availableIntegrations}
					isSubmitting={shareReportState.isSharing}
					accountId={accountIdFromHook}
					facilityId={facilityIdFromHook}
					redirectAfter={handleCloseShareReport}
				/>
			)}
		</Page >
	);
};

export default HospitalPage;
